import React from 'react';
import type { IconProps } from '../types';

export const ToolLayout = (props: IconProps) => (
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <title>tool-layout</title>
  //   <g
  //     id="tool-layout"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"ToolDragProbe
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     ></rect>
  //     <g
  //       id="Group"
  //       transform="translate(0.5, 4)"
  //       strokeLinecap="round"
  //     >
  //       <g
  //         id="Group-3"
  //         transform="translate(0, 0)"
  //         stroke="currentColor"
  //         strokeWidth="1.25"
  //       >
  //         <path
  //           d="M5.45696821e-12,9.49450549 L5.45696821e-12,17.3947362 C5.45710348e-12,18.4993057 0.8954305,19.3947362 2,19.3947362 L13.2443085,19.3947362 L13.2443085,19.3947362"
  //           id="Path-3"
  //         ></path>
  //         <path
  //           d="M9.49450549,0 L9.49450549,4.91369247 L9.49450549,6 C9.49450549,7.1045695 10.389936,8 11.4945055,8 L19.195248,8 L19.195248,8"
  //           id="Path-3"
  //           transform="translate(14.3449, 4) rotate(180) translate(-14.3449, -4)"
  //         ></path>
  //         <path
  //           d="M0.0997440877,-0.0997440877 L0.0997440877,7.80048659 C0.0997440877,8.90505609 0.995174588,9.80048659 2.09974409,9.80048659 L9.80048659,9.80048659 L9.80048659,9.80048659"
  //           id="Path-3"
  //           transform="translate(4.9501, 4.8504) rotate(90) translate(-4.9501, -4.8504)"
  //         ></path>
  //       </g>
  //       <g
  //         id="Group-10"
  //         opacity="0.550000012"
  //         transform="translate(2, 2)"
  //         stroke="currentColor"
  //         strokeWidth="1.5"
  //       >
  //         <line
  //           x1="7.5"
  //           y1="14.5"
  //           x2="7.5"
  //           y2="0.5"
  //           id="Line-2"
  //         ></line>
  //         <line
  //           x1="7"
  //           y1="14"
  //           x2="7"
  //           y2="1"
  //           id="Line-2"
  //           transform="translate(7, 7.5) rotate(90) translate(-7, -7.5)"
  //         ></line>
  //       </g>
  //       <g
  //         id="gear"
  //         transform="translate(21.0876, 17.2796) rotate(-20) translate(-21.0876, -17.2796)translate(15.9634, 11.5127)"
  //         stroke="#348CFD"
  //         strokeLinejoin="round"
  //         strokeWidth="1.25"
  //       >
  //         <circle
  //           id="Oval"
  //           cx="5.12378058"
  //           cy="5.76719178"
  //           r="1.28158482"
  //         ></circle>
  //         <path
  //           d="M6.21361819,0.80762797 L6.59086967,2.04907966 C6.72061095,2.47639719 7.15892721,2.73042581 7.59419808,2.63056421 L8.85259487,2.33893009 C9.34216301,2.22858155 9.84650092,2.45011894 10.0964357,2.88530436 C10.3463705,3.32048979 10.2835655,3.86774756 9.94154064,4.23499782 L9.06128718,5.18481538 C8.75980718,5.51248709 8.75980718,6.0165454 9.06128718,6.3442171 L9.94154064,7.29403466 C10.2835655,7.66128493 10.3463705,8.2085427 10.0964357,8.64372812 C9.84650092,9.07891354 9.34216301,9.30045094 8.85259487,9.1901024 L7.59419808,8.89846827 C7.15663131,8.79632613 6.71524652,9.05279063 6.58730228,9.48352022 L6.2100508,10.7249719 C6.0649735,11.2053044 5.62242271,11.5339347 5.12065911,11.5339347 C4.61889551,11.5339347 4.17634472,11.2053044 4.03126742,10.7249719 L3.65669148,9.48352022 C3.52807698,9.05567912 3.08963152,8.80095947 2.65425492,8.90114382 L1.39585813,9.19277794 C0.90628999,9.30312648 0.401952083,9.08158909 0.152017275,8.64640366 C-0.0979175321,8.21121824 -0.035112502,7.66396047 0.306912358,7.29671021 L1.18716582,6.34689264 C1.48864582,6.01922094 1.48864582,5.51516263 1.18716582,5.18749093 L0.306912358,4.23767336 C-0.035112502,3.8704231 -0.0979175321,3.32316533 0.152017275,2.88797991 C0.401952083,2.45279448 0.90628999,2.23125709 1.39585813,2.34160563 L2.65425492,2.63323975 C3.08937078,2.73350334 3.52770594,2.47923776 3.65669148,2.0517552 L4.03483481,0.810303513 C4.17932126,0.32979188 4.62146882,0.000617032116 5.12323309,0 C5.62499736,-0.000615299293 6.06795204,0.327472644 6.21361819,0.80762797 Z"
  //           id="Path"
  //         ></path>
  //       </g>
  //     </g>
  //   </g>
  // </svg>
  // <svg
  //   xmlns="http://www.w3.org/2000/svg"
  //   fill="currentColor"
  //   viewBox="-70 -80 958.72 958.75"
  //   {...props}
  // >
  //   <path d="M305.29 0c3.73 1.16 7.49 2.21 11.17 3.52a58.73 58.73 0 0 1 39.11 55q.26 166.65 0 333.28a58.49 58.49 0 0 1-58.47 58.59q-119.23.44-238.47 0a58.55 58.55 0 0 1-58.47-58.6q-.33-166.64 0-333.27c0-27.3 18.9-50.27 45.48-56.89 1.63-.4 3.2-1 4.8-1.58ZM332 225.57V64.84c0-27.36-13.66-41.13-40.79-41.13H64.56c-26.83 0-40.76 13.81-40.76 40.43v322.19c0 26.26 14 40.41 40.05 40.41h228.13c25.74 0 40-14.16 40-39.7q.02-80.75.02-161.47m426.72 482.71c-3.87 8.69-6.58 18.15-11.82 25.91-10.76 15.92-26.79 24.22-45.92 24.3q-120 .47-240 0c-31.65-.14-57.7-26.13-57.78-57.72q-.43-167.37 0-334.75c.08-31.59 26.16-57.56 57.79-57.69q120-.51 240 0c26.55.1 49.24 18.83 56 44.73.48 1.87 1.16 3.68 1.76 5.51ZM426.8 533.44v160.73c0 26.77 13.88 40.78 40.42 40.78h227.39c26.26 0 40.39-14 40.39-40.07V371.94c0-25.8-14.1-40-39.68-40H466.45c-25.25 0-39.64 14.27-39.64 39.32q-.03 81.07-.01 162.18m331.92-323.03c-3.87 8.69-6.58 18.15-11.83 25.91-10.75 15.92-26.78 24.22-45.92 24.3q-120 .46-240 0c-31.64-.13-57.51-26.14-57.77-57.73q-.6-72.58 0-145.17c.19-26.8 19.14-49.6 45.44-56.15 1.63-.4 3.2-1 4.8-1.58h254.9c1.58.53 3.15 1.16 4.76 1.58 19 5 32.66 16.41 40.71 34.3 2.08 4.63 3.29 9.65 4.91 14.5ZM580.87 23.7h-114c-25.77 0-40 14.12-40 39.68v134c0 25.19 14.33 39.63 39.34 39.63H695.8c24.7 0 39.25-14.43 39.27-38.95V62.53c0-24.26-14.51-38.85-38.6-38.88q-57.83.02-115.6.05M177.8 758.66H62.25C25.25 758.6.1 733.28.06 696.17Q0 628.02.06 559.88c.05-36.58 25.38-61.95 61.93-62q115.92-.09 231.84 0c36.46 0 61.76 25.47 61.82 62.1q.1 68.51 0 137c-.07 36.09-25.52 61.54-61.56 61.62-38.76.13-77.53.06-116.29.06m-.32-23.71h115.54c24.22 0 38.91-14.54 38.93-38.54q.07-68.13 0-136.27c0-24-14.7-38.54-38.92-38.54H62.7c-24.5 0-38.92 14.56-38.94 39.27v134.79c0 25 14.43 39.29 39.67 39.3q57.03.02 114.05-.01" />
  // </svg>
  <svg
    viewBox="-7 -6 65 65"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19 49H3c-1.1 0-2-.9-2-2V21c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v26c0 1.1-.9 2-2 2"
      fill="#81e7fa"
    />
    <path
      d="M19 15H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2"
      fill="#f1ce85"
    />
    <path
      d="M47 49H27c-1.1 0-2-.9-2-2V29c0-1.1.9-2 2-2h20c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2"
      fill="#9f9"
    />
    <path
      d="M47 23H27c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h20c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2"
      fill="#db5860"
    />
  </svg>
);

export const ToolClickSegment = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M18.7855 10.7063C19.0677 8.68223 18.754 6.39013 17.3334 4.86666C15.7881 3.20953 13.3171 2.78346 11.098 3.09398C9.51269 3.31581 7.93737 4.03721 6.63198 5.25454C5.24718 6.54592 4.39791 8.17926 4.11016 9.84527C3.74697 11.9481 4.27832 14.1031 5.75643 15.6882C7.30168 17.3453 9.54033 18.0136 11.7594 17.7031"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M15.0003 18.562L15.0714 12.3038C15.0714 12.1629 15.1293 12.0689 15.2452 12.0219C15.3663 11.9749 15.4769 12.0036 15.577 12.108L19.8981 16.502C20.0034 16.6169 20.0271 16.7318 19.9692 16.8467C19.9165 16.9615 19.8164 17.0216 19.669 17.0268L17.9627 17.0973L19.353 20.2929C19.3899 20.366 19.3951 20.4391 19.3688 20.5123C19.3477 20.5854 19.303 20.6376 19.2345 20.6689L18.4445 20.9822C18.3708 21.0083 18.2997 21.0057 18.2312 20.9744C18.1628 20.943 18.1128 20.8908 18.0812 20.8177L16.754 17.5673L15.5533 18.7656C15.4532 18.8648 15.3347 18.8935 15.1978 18.8518C15.0609 18.81 14.995 18.7134 15.0003 18.562Z"
      fill="currentColor"
    />
  </svg>
);

export const ToolLength = (props: IconProps) => (
  <svg
    width="22"
    height="22"
    viewBox="-3 -3 28 28"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      fill="none"
      strokeWidth="1.467"
      stroke="currentColor"
    >
      <path
        d="M17.322 4.678 4.677 17.322"
        strokeLinejoin="bevel"
      />
      <path
        stroke="#db5860"
        d="M1.734 17.322h2.944v2.944H1.734zM17.322 1.734h2.944v2.944h-2.944z"
      />
    </g>
  </svg>
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <g
  //     id="tool-length"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     ></rect>
  //     <g
  //       id="ruler"
  //       transform="translate(2, 2.5)"
  //       stroke="currentColor"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     >
  //       <rect
  //         id="Rectangle"
  //         strokeWidth="1.5"
  //         transform="translate(11.5003, 11.5005) rotate(-45.001) translate(-11.5003, -11.5005)"
  //         x="-0.874220029"
  //         y="7.6109894"
  //         width="24.749"
  //         height="7.779"
  //         rx="1"
  //       ></rect>
  //       <line
  //         x1="5.11737261"
  //         y1="12.3844231"
  //         x2="7.13237261"
  //         y2="14.3684231"
  //         id="Path"
  //       ></line>
  //       <line
  //         x1="7.68571234"
  //         y1="9.81508336"
  //         x2="10.1857123"
  //         y2="12.3150834"
  //         id="Path"
  //       ></line>
  //       <line
  //         x1="10.1225521"
  //         y1="7.37924362"
  //         x2="11.8725521"
  //         y2="9.12924362"
  //         id="Path"
  //       ></line>
  //       <line
  //         x1="12.5583918"
  //         y1="4.94240389"
  //         x2="15.0583918"
  //         y2="7.44240389"
  //         id="Path"
  //       ></line>
  //       <line
  //         x1="15.1127315"
  //         y1="2.38806416"
  //         x2="17.1277315"
  //         y2="4.37406416"
  //         id="Path"
  //       ></line>
  //       <line
  //         x1="2.56403288"
  //         y1="14.9377628"
  //         x2="5.06403288"
  //         y2="17.4377628"
  //         id="Path"
  //       ></line>
  //     </g>
  //   </g>
  // </svg>
);

export const Tool3DRotate = (props: IconProps) => (
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <g
  //     id="tool-3d-rotate"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     />
  //     <g
  //       id="Group"
  //       transform="translate(4, 3)"
  //       stroke="currentColor"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //       strokeWidth="1.5"
  //     >
  //       <g id="group">
  //         <polyline
  //           id="Path"
  //           points="6 21.996 8.5 19.998 6 17.996"
  //         />
  //         <path
  //           d="M8.5,19.998 C5.038,20.652 1,18.498 0,14.998"
  //           id="Path"
  //         />
  //         <polyline
  //           id="Path"
  //           points="14 0 11.5 1.998 14 4"
  //         />
  //         <path
  //           d="M11.5,1.998 C14.962,1.344 19,3.498 20,6.998"
  //           id="Path"
  //         />
  //       </g>
  //       <g
  //         id="3d"
  //         transform="translate(5, 5.75)"
  //       >
  //         <polygon
  //           id="Path"
  //           points="5 0 0 2.1875 5 4.375 10 2.1875"
  //         />
  //         <polyline
  //           id="Path"
  //           points="0 2.1875 0 8.125 5 10.3125 10 8.125 10 2.1875"
  //         />
  //         <line
  //           x1="5"
  //           y1="4.375"
  //           x2="5"
  //           y2="10.3125"
  //           id="Path"
  //         />
  //       </g>
  //     </g>
  //   </g>
  // </svg>
  <svg
    fill="currentColor"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 0h24v24H0z"
      fill="none"
    />
    <path d="M7.53 21.48A10.49 10.49 0 0 1 1.56 13H.06c.51 6.16 5.66 11 11.95 11l.66-.03-3.81-3.81zm.89-6.52c-.19 0-.37-.03-.52-.08a1.1 1.1 0 0 1-.4-.24c-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95s.33.5.56.69c.24.18.51.32.82.41q.45.15.96.15c.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44s.42-.43.55-.72.2-.61.2-.97c0-.19-.02-.38-.07-.56s-.12-.35-.23-.51c-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31a2.1 2.1 0 0 0 .89-.75c.1-.15.17-.3.22-.46s.07-.32.07-.48q0-.54-.18-.96c-.18-.42-.29-.51-.51-.69-.2-.19-.47-.33-.77-.43C9.11 8.05 8.77 8 8.4 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3q0-.255.09-.45c.09-.195.14-.25.25-.34s.23-.17.38-.22.3-.08.48-.08c.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49s-.14.27-.25.37-.25.18-.41.24-.36.09-.58.09h-.77v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4s.1.35.1.57c0 .41-.12.72-.35.93-.23.23-.55.33-.95.33m8.55-5.92c-.32-.33-.7-.59-1.14-.77S14.9 8 14.36 8H12v8h2.3c.55 0 1.06-.09 1.51-.27s.84-.43 1.16-.76.57-.73.74-1.19c.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57s-.42-.87-.74-1.2m-.39 3.16c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85s-.43.41-.71.53q-.435.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99zM12.01 0l-.66.03 3.81 3.81 1.33-1.33c3.27 1.55 5.61 4.72 5.96 8.48h1.5C23.45 4.84 18.3 0 12.01 0" />
  </svg>
);

export const ToolAngle = (props: IconProps) => (
  <svg
    width="64"
    height="64"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      fill="none"
      strokeWidth="1.467"
    >
      <path
        d="M17.432 3.951 4.768 10.052M11.5 6.701c2.26 2.784 2.957 5.541 0 8.235m5.822 2.627L4.649 11.858"
        stroke="currentColor"
        strokeLinejoin="bevel"
      />
      <path
        d="M1.734 9.528h2.944v2.944H1.734zm15.588 8.035h2.944v2.944h-2.944zm0-15.829h2.944v2.944h-2.944z"
        stroke="#db5860"
      />
    </g>
  </svg>
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <g
  //     id="tool-angle"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     />
  //     <g
  //       id="Group-6"
  //       transform="translate(2.4559, 6)"
  //       stroke="currentColor"
  //       strokeLinecap="round"
  //       strokeWidth="1.5"
  //     >
  //       <line
  //         x1="2.5"
  //         y1="14.5"
  //         x2="20.6875"
  //         y2="14.4375"
  //         id="Line-4"
  //       />
  //       <line
  //         x1="1"
  //         y1="13.3775095"
  //         x2="13.0650095"
  //         y2="1.3125"
  //         id="Line-4"
  //         transform="translate(7.0325, 7.345) rotate(-10) translate(-7.0325, -7.345)"
  //       />
  //     </g>
  //     <path
  //       d="M19.3390559,17.0930296 C19.4124327,13.0930296 17.4130821,11.0930296 13.3410041,11.0930296"
  //       id="Path-4"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeDasharray="1,2.7"
  //       transform="translate(16.341, 14.093) rotate(12) translate(-16.341, -14.093)"
  //     />
  //   </g>
  // </svg>
);

export const ToolAnnotate = (props: IconProps) => (
  <svg
    width="22"
    height="22"
    viewBox="0 -3 25 35"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.114 2h15.772L19 6.602h-.684c-.325-1.45-.739-2.33-1.24-2.767s-1.56-.545-3.168-.545h-1.572l-.016 13.741c0 1.05.232 1.701.562 1.953q.495.378 2.166.497V20H6.953v-.52q1.782-.132 2.222-.565.438-.433.438-2.182V3.29h-1.52c-1.542 0-2.592.105-3.15.538s-.978 1.315-1.259 2.774H3z"
      fill="currentColor"
    />
  </svg>
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <g
  //     id="tool-annotate"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     />
  //     <g
  //       id="Group"
  //       transform="translate(4, 3.3899)"
  //       stroke="currentColor"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //       strokeWidth="1.5"
  //     >
  //       <polyline
  //         id="Path"
  //         points="8.59335038 20.2520716 -6.1284311e-14 20.2520716 -6.1284311e-14 11.6587212"
  //       />
  //       <line
  //         x1="-4.08562073e-14"
  //         y1="20.2520716"
  //         x2="19.6419437"
  //         y2="0.610127877"
  //         id="Path"
  //       />
  //     </g>
  //   </g>
  // </svg>
);

export const ToolBidirectional = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="-50 -40 580 580"
    {...props}
  >
    <path d="M472.863 175.662 353.396 56.195c-6.666-6.664-17.472-6.662-24.136.004a17.07 17.07 0 0 0-4.997 12.063v51.2H204.796c-9.426 0-17.067 7.641-17.067 17.067s7.641 17.067 17.067 17.067H341.33c9.426 0 17.067-7.641 17.067-17.067V109.46l78.268 78.268-78.268 78.268v-27.068c0-9.426-7.641-17.067-17.067-17.067H153.596v-51.2c-.002-9.426-7.645-17.065-17.07-17.063a17.07 17.07 0 0 0-12.063 4.997L4.997 278.062c-6.663 6.665-6.663 17.468 0 24.132l119.467 119.467c3.2 3.201 7.54 5 12.066 5.001a16.9 16.9 0 0 0 6.536-1.297 17.07 17.07 0 0 0 10.53-15.77v-51.2h119.467c9.426 0 17.067-7.641 17.067-17.067s-7.641-17.067-17.067-17.067H136.53c-9.426 0-17.067 7.641-17.067 17.067v27.068l-78.268-78.268 78.268-78.268v27.068c0 9.426 7.641 17.067 17.067 17.067h187.733v51.2c.002 9.426 7.645 17.065 17.07 17.063a17.07 17.07 0 0 0 12.063-4.997l119.467-119.467c6.662-6.665 6.662-17.468 0-24.132" />
  </svg>
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <title>tool-bidirectional</title>
  //   <g
  //     id="tool-bidirectional"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     ></rect>
  //     <g
  //       id="group"
  //       transform="translate(2.5, 2.5)"
  //       stroke="currentColor"
  //     >
  //       <g
  //         id="Group-5"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       >
  //         <path
  //           d="M19.7288691,-0.335661423 C20.1766848,-0.335701004 20.6245155,-0.164922663 20.9661629,0.176604012 L22.785192,1.99444856 C23.0988548,2.30800052 23.2685446,2.7110041 23.2944775,3.12134197 C23.3217954,3.55359523 23.188997,3.99381095 22.8972982,4.34658876 L4.09686309,23.1566959 C3.72728287,23.5261645 3.24294798,23.7108988 2.75861309,23.7108988 C2.2742782,23.7108988 1.78994331,23.5261645 1.420283,23.1566158 L-0.19579707,21.5405357 C-0.56526569,21.1709555 -0.75,20.6866206 -0.75,20.2022857 C-0.75,19.7179508 -0.56526569,19.2336159 -0.195713448,18.8639521 L18.4915869,0.176901703 C18.833253,-0.16476434 19.2810535,-0.335621842 19.7288691,-0.335661423 Z"
  //           id="Path"
  //           strokeWidth="1.5"
  //         ></path>
  //         <line
  //           x1="4.1448988"
  //           y1="18.9142857"
  //           x2="5.71632738"
  //           y2="20.4765714"
  //           id="Path"
  //         ></line>
  //         <line
  //           x1="6.5688988"
  //           y1="16.4902857"
  //           x2="8.14261309"
  //           y2="18.0502857"
  //           id="Path"
  //         ></line>
  //         <line
  //           x1="8.9928988"
  //           y1="14.0662857"
  //           x2="10.5654702"
  //           y2="15.6274286"
  //           id="Path"
  //         ></line>
  //         <line
  //           x1="11.4168988"
  //           y1="11.6422857"
  //           x2="12.9917559"
  //           y2="13.2011429"
  //           id="Path"
  //         ></line>
  //         <line
  //           x1="13.8408988"
  //           y1="9.21714286"
  //           x2="15.4066131"
  //           y2="10.7874286"
  //           id="Path"
  //         ></line>
  //         <line
  //           x1="16.1345622"
  //           y1="6.9234795"
  //           x2="17.7002765"
  //           y2="8.49376521"
  //           id="Path"
  //         ></line>
  //         <line
  //           x1="18.5589283"
  //           y1="4.49911339"
  //           x2="20.1246426"
  //           y2="6.0693991"
  //           id="Path"
  //         ></line>
  //       </g>
  //       <path
  //         d="M9.21155442,3 L3.86096848,3 C3.30868373,3 2.86096848,3.44771525 2.86096848,4 L2.86096848,6.5 C2.86096848,7.05228475 3.30868373,7.5 3.86096848,7.5 L9.21155442,7.5 L9.21155442,7.5"
  //         id="Path-6"
  //         strokeWidth="1.5"
  //         transform="translate(6.0363, 5.25) rotate(-315) translate(-6.0363, -5.25)"
  //       ></path>
  //       <path
  //         d="M21.0115544,14.7862614 L15.6609685,14.7862614 C15.1086837,14.7862614 14.6609685,15.2339767 14.6609685,15.7862614 L14.6609685,18.2862614 C14.6609685,18.8385462 15.1086837,19.2862614 15.6609685,19.2862614 L21.0115544,19.2862614 L21.0115544,19.2862614"
  //         id="Path-6"
  //         strokeWidth="1.5"
  //         transform="translate(17.8363, 17.0363) rotate(-135) translate(-17.8363, -17.0363)"
  //       ></path>
  //     </g>
  //   </g>
  // </svg>
);

export const ToolCalibrate = (props: IconProps) => (
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <g
  //     id="tool-calibrate"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     ></rect>
  //     <g
  //       id="calibrate"
  //       transform="translate(2.5, 16.5)"
  //       stroke="currentColor"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //       strokeWidth="1.25"
  //     >
  //       <polyline
  //         id="Path"
  //         points="20 6 23 3 20 0"
  //       ></polyline>
  //       <line
  //         x1="1"
  //         y1="3"
  //         x2="22"
  //         y2="3"
  //         id="Path"
  //       ></line>
  //       <polyline
  //         id="Path"
  //         points="3 6 0 3 3 0"
  //       ></polyline>
  //     </g>
  //     <rect
  //       id="Rectangle"
  //       stroke="currentColor"
  //       strokeWidth="1.25"
  //       x="2"
  //       y="5"
  //       width="24"
  //       height="6"
  //       rx="2"
  //     ></rect>
  //     <line
  //       x1="6.5"
  //       y1="10.5"
  //       x2="6.5"
  //       y2="8.5"
  //       id="Line-5"
  //       stroke="currentColor"
  //       strokeLinecap="round"
  //     ></line>
  //     <line
  //       x1="9.5"
  //       y1="10.5"
  //       x2="9.5"
  //       y2="8.5"
  //       id="Line-5"
  //       stroke="currentColor"
  //       strokeLinecap="round"
  //     ></line>
  //     <line
  //       x1="12.5"
  //       y1="10.5"
  //       x2="12.5"
  //       y2="8.5"
  //       id="Line-5"
  //       stroke="currentColor"
  //       strokeLinecap="round"
  //     ></line>
  //     <line
  //       x1="15.5"
  //       y1="10.5"
  //       x2="15.5"
  //       y2="8.5"
  //       id="Line-5"
  //       stroke="currentColor"
  //       strokeLinecap="round"
  //     ></line>
  //     <line
  //       x1="18.5"
  //       y1="10.5"
  //       x2="18.5"
  //       y2="8.5"
  //       id="Line-5"
  //       stroke="currentColor"
  //       strokeLinecap="round"
  //     ></line>
  //     <line
  //       x1="21.5"
  //       y1="10.5"
  //       x2="21.5"
  //       y2="8.5"
  //       id="Line-5"
  //       stroke="currentColor"
  //       strokeLinecap="round"
  //     ></line>
  //   </g>
  // </svg>
  <svg
    height="25"
    viewBox="-50 -60 612 612"
    width="25"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M98.59 400.522V20.388C98.59 13.27 92.82 7.5 85.702 7.5H20.388C13.27 7.5 7.5 13.27 7.5 20.388v471.224c0 7.118 5.77 12.888 12.888 12.888h471.224c7.118 0 12.888-5.77 12.888-12.888v-65.314c0-7.118-5.77-12.888-12.888-12.888H111.478c-7.117 0-12.888-5.771-12.888-12.888"
      fill="#95d6a4"
    />
    <path
      d="M491.612 413.41h-52.445v41.858c0 15.04-12.192 27.232-27.232 27.232H7.5v9.112c0 7.118 5.77 12.888 12.888 12.888h471.224c7.118 0 12.888-5.77 12.888-12.888v-65.314c0-7.118-5.77-12.888-12.888-12.888"
      fill="#78c2a4"
    />
    <path
      d="M410.437 262.235v-99.124a15.06 15.06 0 0 0-7.532-13.045l-85.844-49.562a15.06 15.06 0 0 0-15.063 0l-85.844 49.562a15.06 15.06 0 0 0-7.532 13.045v99.124a15.06 15.06 0 0 0 7.532 13.045l85.844 49.562a15.06 15.06 0 0 0 15.063 0l85.844-49.562a15.06 15.06 0 0 0 7.532-13.045"
      fill="#bed8fb"
    />
    <path
      d="m309.53 212.673 98.889-57.093a15.06 15.06 0 0 0-5.514-5.514l-85.844-49.562a15.06 15.06 0 0 0-15.063 0l-85.844 49.562a15.06 15.06 0 0 0-5.514 5.514z"
      fill="#9dc6fb"
    />
    <path
      fill="currentColor"
      d="M165.687 102.646c4.143 0 7.5-3.357 7.5-7.5V76.329h18.641c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-20.522c-7.233 0-13.118 5.885-13.118 13.119v20.697a7.5 7.5 0 0 0 7.499 7.501m261.891-26.317h18.296v18.816c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5V74.448c0-7.234-5.885-13.119-13.119-13.119h-20.177c-4.143 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5m0 287.689h20.177c7.234 0 13.119-5.885 13.119-13.119v-20.003c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v18.122h-18.296c-4.143 0-7.5 3.357-7.5 7.5s3.358 7.5 7.5 7.5m-256.273 0h20.522c4.143 0 7.5-3.357 7.5-7.5s-3.357-7.5-7.5-7.5h-18.641v-18.122c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v20.003c.001 7.234 5.885 13.119 13.119 13.119"
    />
    <path
      fill="currentColor"
      d="M491.612 405.909H111.479a5.394 5.394 0 0 1-5.388-5.388V20.388C106.091 9.146 96.944 0 85.702 0H20.388C9.146 0 0 9.146 0 20.388v121.997c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5V20.388A5.394 5.394 0 0 1 20.388 15h65.314a5.394 5.394 0 0 1 5.389 5.388v36.445H65.667c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h25.424v32.792H75.5c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h15.591v32.791H65.667c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h25.424v32.792H75.5c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h15.591v32.791H65.667c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h25.424v32.792H75.5c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h15.591v32.792H65.667c-4.143 0-7.5 3.357-7.5 7.5s3.357 7.5 7.5 7.5h25.424v41.938c0 2.877.599 5.617 1.679 8.101L15 486.393V177.447c0-4.143-3.357-7.5-7.5-7.5s-7.5 3.357-7.5 7.5v314.165C0 502.849 9.14 512 20.388 512h471.225c11.242 0 20.388-9.146 20.388-20.388v-65.314c-.001-11.242-9.147-20.389-20.389-20.389M497 491.612a5.394 5.394 0 0 1-5.388 5.388H25.607l77.77-77.77a20.3 20.3 0 0 0 8.101 1.679h37.177v25.439c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-25.439h32.792v15.606c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-15.606h32.791v25.439c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-25.439h32.792v15.606c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-15.606h32.791v25.439c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-25.439h32.792v15.606c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-15.606h32.791v25.439c0 4.143 3.357 7.5 7.5 7.5s7.5-3.357 7.5-7.5v-25.439h41.208a5.394 5.394 0 0 1 5.388 5.389z"
    />
    <path
      fill="currentColor"
      d="m212.405 281.775 85.843 49.562c6.96 4.018 15.605 4.019 22.563 0l85.843-49.562a22.62 22.62 0 0 0 11.282-19.54v-99.124c0-8.024-4.315-15.519-11.281-19.54L320.812 94.01a22.63 22.63 0 0 0-22.564 0l-85.842 49.562a22.63 22.63 0 0 0-11.283 19.54v99.124c0 8.035 4.323 15.523 11.282 19.539m7.499-12.99a7.59 7.59 0 0 1-3.781-6.55v-94.83l85.907 49.598V316.2zM305.748 107a7.58 7.58 0 0 1 7.563 0l82.125 47.415-28.285 16.33a7.5 7.5 0 0 0-2.745 10.245c2.08 3.605 6.675 4.806 10.245 2.745l28.285-16.33v94.83a7.58 7.58 0 0 1-3.781 6.55l-82.125 47.414v-99.196l26.736-15.436a7.5 7.5 0 0 0-7.5-12.99l-26.736 15.436-85.907-49.598z"
    />
  </svg>
);

export const ToolCapture = (props: IconProps) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.468 1.468v9.357H5.72a3.68 3.101 0 0 1 .053-.209 3.68 3.101 0 0 1 .185-.413 3.68 3.101 0 0 1 .252-.39 3.68 3.101 0 0 1 .314-.354 3.68 3.101 0 0 1 .371-.312 3.68 3.101 0 0 1 .42-.265 3.68 3.101 0 0 1 .461-.212 3.68 3.101 0 0 1 .492-.155 3.68 3.101 0 0 1 .513-.094 3.68 3.101 0 0 1 .525-.03 3.68 3.101 0 0 1 .102.001l3.288-3.288V1.468z"
      fill="none"
      stroke="currentColor"
      strokeWidth=".936"
    />
    <g
      transform="translate(-.3)"
      fill="currentColor"
    >
      <path d="M4.748 5.854 2.023 7.803 2 10.66l3.802.12L7.66 8.752s-1.427-1.228-2.912-2.9" />
      <circle
        cx="9"
        cy="5"
        r="1.5"
      />
    </g>
    <g fill="#389fd6">
      <path
        d="M10.91 10.816a2.51 2.51 0 0 0-2.871.503c-.977.977-.977 2.576 0 3.553s2.576.977 3.553 0c.77-.77.918-1.924.503-2.872l1.273-1.273.889.888 1.184-1.184-.888-.888.592-.592-1.185-1.185zm-.502 2.872c-.326.326-.86.326-1.185 0s-.325-.859 0-1.184.859-.326 1.185 0 .325.858 0 1.184"
        opacity=".3"
      />
      <path d="M11.888 15.168c-1.155 1.155-2.99 1.155-4.145 0s-1.155-2.99 0-4.145c.8-.8 2.013-1.066 3.05-.68l3.167-3.169 1.777 1.777-.592.592.888.888-1.776 1.777-.889-.889-.8.8c.386 1.036.12 2.25-.68 3.05m-3.553-3.554c-.829.83-.829 2.132 0 2.961s2.132.83 2.96 0c.623-.622.8-1.57.415-2.368l-.148-.267 1.806-1.806.889.888.592-.592-.889-.888.593-.592-.593-.593-2.99 2.99-.266-.147a2.08 2.08 0 0 0-2.369.414" />
      <path d="M10.704 13.984c-.504.503-1.274.503-1.777 0s-.503-1.273 0-1.776 1.273-.504 1.777 0 .503 1.273 0 1.776M9.519 12.8c-.177.177-.177.414 0 .592s.415.177.592 0 .178-.415 0-.592-.414-.178-.592 0" />
    </g>
  </svg>
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <title>tool-</title>
  //   <g
  //     id="tool-"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     ></rect>
  //     <path
  //       d="M8.64381845,8.55555556 C9.05021618,8.5340019 9.43897503,8.38261884 9.75292956,8.12366667 L11.6057073,6.43188889 C11.919523,6.17269999 12.308363,6.02128533 12.7148185,6 L15.6179296,6 C16.0208348,6.0234362 16.4057732,6.17472593 16.7168185,6.43188889 L18.5695962,8.12366667 C18.8835508,8.38261884 19.2723096,8.5340019 19.6787073,8.55555556 L23.1057073,8.55555556 C24.2042675,8.66849081 25.0354336,9.60050503 25.0225258,10.7047778 L25.0225258,19.4166667 C25.0225258,20.4752124 24.1642531,21.3333333 23.1057073,21.3333333 L5.21681845,21.3333333 C4.15827268,21.3333333 3.3,20.4752124 3.3,19.4166667 L3.3,10.7047778 C3.28709219,9.60050503 4.11825826,8.66849081 5.21681845,8.55555556 L8.64381845,8.55555556 Z"
  //       id="Path"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     ></path>
  //     <circle
  //       id="Oval"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //       cx="14.1612629"
  //       cy="13.9861111"
  //       r="3.51388889"
  //     ></circle>
  //     <path
  //       d="M21.8279296,11.4305556 C22.0043539,11.4305556 22.147374,11.5735757 22.147374,11.75 C22.147374,11.9264243 22.0043539,12.0694444 21.8279296,12.0694444 C21.6515053,12.0694444 21.5084851,11.9264243 21.5084851,11.75 C21.5084851,11.5735757 21.6515053,11.4305556 21.8279296,11.4305556"
  //       id="Path"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     ></path>
  //   </g>
  // </svg>
);

export const ToolCine = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-50 -60 1480 1224"
    fill="currentColor"
    {...props}
  >
    <path d="M912.3 839.5H99V160h813.3c19.6 13 26.8 31.1 24.9 54.4-1.4 17.2-.3 34.6-.3 51.9V410c8.3-5.6 13.2-8.3 17.2-11.8 62.4-53.7 124.9-107.4 187.1-161.4 32.4-28.2 44.6-28 73.7 2.5v520.8c-27.4 28.8-41.2 30.6-68.1 7.4-62.5-53.7-124.7-107.7-187.1-161.4-5.9-5.1-12.3-9.7-22.8-17.8v28.6c0 56-.9 112.1.4 168.1.7 23.4-5.4 41.5-25 54.5" />
  </svg>
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <g
  //     id="tool-cine"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     ></rect>
  //     <circle
  //       id="Oval"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //       cx="14"
  //       cy="13.9990833"
  //       r="10.5416667"
  //     ></circle>
  //     <path
  //       d="M11.5416667,11.7236444 L17.3036401,14.0295711 L11.5416667,16.9105578 L11.5416667,11.7236444 Z"
  //       id="Path"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       fill="currentColor"
  //     ></path>
  //   </g>
  // </svg>
);

export const ToolCircle = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-circle"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <circle
        id="Oval"
        stroke="currentColor"
        strokeWidth="1.5"
        cx="14"
        cy="14"
        r="9.5"
      ></circle>
    </g>
  </svg>
);

export const ToolSpineLabeling = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    fill="none"
    {...props}
  >
    <g
      fill="currentColor"
      clipPath="url(#a)"
    >
      <path d="M20.5 4.279v4.765a1.02 1.02 0 0 1-1.017 1.02h-6.102l-1.881-3.4 1.877-3.402h6.103-.004c.558.007 1.01.462 1.01 1.02zM13.783 9.38h5.703a.34.34 0 0 0 .337-.34V4.279l-.003.003a.346.346 0 0 0-.34-.34h-5.705l-1.502 2.721z" />
      <path d="M13.402 6.66a.51.51 0 1 0 1.019 0 .51.51 0 0 0-1.019 0m-3.039 9.66a.3.3 0 0 1-.203.085l-1.007-.027a.54.54 0 0 0-.551.522l-.015.556-.395.167a5.4 5.4 0 0 1-4.486-.123l-.386-.189.014-.555a.53.53 0 0 0-.146-.384.53.53 0 0 0-.375-.168l-1.008-.028c-.108-.002-.184-.078-.22-.123a.57.57 0 0 1-.116-.373.57.57 0 0 1 .136-.366c.038-.042.113-.119.226-.11l1.01.028a.53.53 0 0 0 .549-.522l.017-.637.03.015c1.634.799 3.53.85 5.205.143l.032-.013-.017.638a.54.54 0 0 0 .521.55l1.009.027c.189.005.343.233.335.496a.56.56 0 0 1-.159.39m-.153-1.754-.676-.02.021-.802a.55.55 0 0 0-.24-.478.52.52 0 0 0-.499-.05l-.511.216a5.4 5.4 0 0 1-4.487-.123l-.5-.245a.52.52 0 0 0-.5.024.56.56 0 0 0-.265.463l-.022.804-.676-.019a1.18 1.18 0 0 0-.896.398 1.44 1.44 0 0 0-.357.923c-.01.349.1.683.307.94.221.275.54.438.873.447l.676.018-.01.42a.55.55 0 0 0 .304.518l.573.28a6.28 6.28 0 0 0 5.205.142l.586-.248a.56.56 0 0 0 .333-.498l.012-.421.676.018c.3.01.593-.106.823-.323.263-.25.42-.613.43-.997.02-.747-.51-1.368-1.18-1.387" />
      <path d="M10.363 10.288a.3.3 0 0 1-.203.086l-1.007-.028a.54.54 0 0 0-.551.522l-.015.556-.395.167a5.4 5.4 0 0 1-4.486-.123l-.386-.188.014-.556a.53.53 0 0 0-.146-.383.53.53 0 0 0-.375-.169l-1.008-.027c-.108-.003-.184-.078-.22-.123a.57.57 0 0 1-.116-.373.57.57 0 0 1 .136-.366c.038-.043.113-.12.226-.11l1.01.027a.53.53 0 0 0 .549-.522l.017-.636.03.015c1.634.798 3.53.85 5.205.143l.032-.014-.017.638a.54.54 0 0 0 .521.55l1.009.028c.189.005.343.232.335.496a.56.56 0 0 1-.159.39m-.153-1.754-.676-.019.021-.803a.55.55 0 0 0-.24-.477.52.52 0 0 0-.499-.05l-.511.215a5.4 5.4 0 0 1-4.487-.123l-.5-.244a.52.52 0 0 0-.5.023.56.56 0 0 0-.265.463l-.022.804-.676-.018a1.18 1.18 0 0 0-.896.398 1.44 1.44 0 0 0-.357.923c-.01.348.1.682.307.94.221.275.54.437.873.446l.676.019-.01.42a.55.55 0 0 0 .304.517l.573.28a6.28 6.28 0 0 0 5.205.143l.586-.248a.56.56 0 0 0 .333-.498l.012-.422.676.019c.3.01.593-.107.823-.324.263-.249.42-.612.43-.997.02-.746-.51-1.368-1.18-1.387m.153-4.29a.3.3 0 0 1-.203.086l-1.007-.027a.54.54 0 0 0-.551.522l-.015.555-.395.167a5.4 5.4 0 0 1-4.486-.123l-.386-.188.014-.556a.53.53 0 0 0-.146-.383.53.53 0 0 0-.375-.169l-1.008-.027c-.108-.003-.184-.078-.22-.123a.57.57 0 0 1-.116-.373.57.57 0 0 1 .136-.366c.038-.043.113-.12.226-.11l1.01.027a.53.53 0 0 0 .549-.522l.017-.636.03.015c1.634.798 3.53.85 5.205.143l.032-.013-.017.637a.54.54 0 0 0 .521.55l1.009.028c.189.005.343.233.335.496a.56.56 0 0 1-.159.39M10.21 2.49l-.676-.019.021-.803a.55.55 0 0 0-.24-.477.52.52 0 0 0-.499-.05l-.511.216a5.4 5.4 0 0 1-4.487-.124l-.5-.244a.52.52 0 0 0-.5.023.56.56 0 0 0-.265.463l-.022.804-.676-.018a1.18 1.18 0 0 0-.896.398 1.44 1.44 0 0 0-.357.923c-.01.348.1.682.307.94.221.275.54.437.873.447l.676.018-.01.42a.55.55 0 0 0 .304.517l.573.28a6.28 6.28 0 0 0 5.205.143l.586-.248a.56.56 0 0 0 .333-.498l.012-.422.676.019c.3.01.593-.107.823-.324.263-.249.42-.612.43-.997.02-.746-.51-1.368-1.18-1.387" />
    </g>
    <defs>
      <clipPath id="a">
        <path
          fill="currentColor"
          d="M.5 0h20v20H.5z"
        />
      </clipPath>
    </defs>
  </svg>
);

export const ToolCobbAngle = (props: IconProps) => (
  <svg
    width="64"
    height="64"
    viewBox="-3 -4 30 30"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      fill="none"
      strokeWidth="1.467"
      stroke="currentColor"
    >
      <path
        d="m4.94 3.243 12.674 3.612M5.98 14.653l8.626-8.716m-8.662 2.02 8.222 8.12m-8.833 2.865 12.25-3.64"
        strokeLinejoin="bevel"
      />
      <path
        stroke="#db5860"
        d="M20.266 13.35h-2.944v2.944h2.944zm0-7.744h-2.944V8.55h2.944zM5.077 17.963H2.133v2.944h2.944zm.101-16.729H2.234v2.944h2.944z"
      />
    </g>
  </svg>
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <g
  //     id="tool-cobb-angle"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     ></rect>
  //     <g
  //       id="Group"
  //       transform="translate(6.5, 0.68)"
  //       fill="currentColor"
  //     >
  //       <path
  //         d="M8.5,10.1817844 C9.88071187,10.1817844 11,11.3010725 11,12.6817844 L11,13.6817844 C11,15.0624963 9.88071187,16.1817844 8.5,16.1817844 L2.5,16.1817844 C1.11928813,16.1817844 0,15.0624963 0,13.6817844 L0,12.6817844 C0,11.3010725 1.11928813,10.1817844 2.5,10.1817844 L8.5,10.1817844 Z M8.5,11.6817844 L2.5,11.6817844 C1.94771525,11.6817844 1.5,12.1294997 1.5,12.6817844 L1.5,13.6817844 C1.5,14.2340692 1.94771525,14.6817844 2.5,14.6817844 L8.5,14.6817844 C9.05228475,14.6817844 9.5,14.2340692 9.5,13.6817844 L9.5,12.6817844 C9.5,12.1294997 9.05228475,11.6817844 8.5,11.6817844 Z"
  //         id="Rectangle"
  //         fillRule="nonzero"
  //       ></path>
  //       <circle
  //         id="Oval"
  //         cx="6.5"
  //         cy="8.6976195"
  //         r="1"
  //       ></circle>
  //       <circle
  //         id="Oval"
  //         cx="6.5"
  //         cy="17.6976195"
  //         r="1"
  //       ></circle>
  //       <path
  //         d="M11.5,1.70018865 C12.8807119,1.70018865 14,2.81947678 14,4.20018865 L14,5.20018865 C14,6.58090053 12.8807119,7.70018865 11.5,7.70018865 L5.5,7.70018865 C4.11928813,7.70018865 3,6.58090053 3,5.20018865 L3,4.20018865 C3,2.81947678 4.11928813,1.70018865 5.5,1.70018865 L11.5,1.70018865 Z M11.5,3.20018865 L5.5,3.20018865 C4.94771525,3.20018865 4.5,3.6479039 4.5,4.20018865 L4.5,5.20018865 C4.5,5.7524734 4.94771525,6.20018865 5.5,6.20018865 L11.5,6.20018865 C12.0522847,6.20018865 12.5,5.7524734 12.5,5.20018865 L12.5,4.20018865 C12.5,3.6479039 12.0522847,3.20018865 11.5,3.20018865 Z"
  //         id="Rectangle"
  //         fillRule="nonzero"
  //         transform="translate(8.5, 4.7002) rotate(20) translate(-8.5, -4.7002)"
  //       ></path>
  //       <path
  //         d="M11.5,18.7001887 C12.8807119,18.7001887 14,19.8194768 14,21.2001887 L14,22.2001887 C14,23.5809005 12.8807119,24.7001887 11.5,24.7001887 L5.5,24.7001887 C4.11928813,24.7001887 3,23.5809005 3,22.2001887 L3,21.2001887 C3,19.8194768 4.11928813,18.7001887 5.5,18.7001887 L11.5,18.7001887 Z M11.5,20.2001887 L5.5,20.2001887 C4.94771525,20.2001887 4.5,20.6479039 4.5,21.2001887 L4.5,22.2001887 C4.5,22.7524734 4.94771525,23.2001887 5.5,23.2001887 L11.5,23.2001887 C12.0522847,23.2001887 12.5,22.7524734 12.5,22.2001887 L12.5,21.2001887 C12.5,20.6479039 12.0522847,20.2001887 11.5,20.2001887 Z"
  //         id="Rectangle"
  //         fillRule="nonzero"
  //         transform="translate(8.5, 21.7002) rotate(-20) translate(-8.5, -21.7002)"
  //       ></path>
  //     </g>
  //   </g>
  // </svg>
);

export const ToolCreateThreshold = (props: IconProps) => (
  <svg
    width="25px"
    height="25px"
    viewBox="0 0 25 25"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="create-threshold"
      stroke="currentColor"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <polyline
        id="Path-3"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        points="18.85656 16.2174437 21.3536565 13.7203472 23.850753 16.2174437"
      ></polyline>
      <polyline
        id="Path-3"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(21.353657, 21.471076) scale(1, -1) translate(-21.353657, -21.471076) "
        points="18.85656 22.7196245 21.3536565 20.222528 23.850753 22.7196245"
      ></polyline>
      <path
        d="M21.8903104,6.56040847 L11.830485,16.6215711 C11.7372012,16.7144344 11.6185826,16.7776976 11.4894966,16.8034316 L7.65571758,17.5696525 C7.43667607,17.6132586 7.21032569,17.5446155 7.05240058,17.3866904 C6.89447547,17.2287653 6.8258324,17.0024149 6.86943853,16.7833734 L7.63565944,12.9509316 C7.66176759,12.8216917 7.72550512,12.7030561 7.81885711,12.6099433 L17.8786825,2.54878063 C18.9836118,1.44420272 20.7746834,1.44420272 21.8796127,2.54878063 L21.8903104,2.56081551 C22.9947353,3.66528595 22.9947353,5.45593803 21.8903104,6.56040847 Z"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <line
        x1="9.60946699"
        y1="12.6534866"
        x2="11.9466763"
        y2="14.9906958"
        id="Line"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="square"
      ></line>
      <path
        d="M-5.52848657,13.180889 L-5.52848657,15.180889 C-5.52848657,16.7687077 -4.24130523,18.055889 -2.65348657,18.055889 L-1.21495403,18.055889 C-0.731704876,18.055889 -0.339954032,17.6641382 -0.339954032,17.180889 C-0.339954032,16.6976399 -0.731704876,16.305889 -1.21495403,16.305889 L-2.65348657,16.305889 C-3.27480692,16.305889 -3.77848657,15.8022094 -3.77848657,15.180889 L-3.77848657,13.180889 C-3.77848657,12.6976399 -4.17023742,12.305889 -4.65348657,12.305889 C-5.13673573,12.305889 -5.52848657,12.6976399 -5.52848657,13.180889 Z M3.03504597,18.055889 L9.53504597,18.055889 C10.0182951,18.055889 10.410046,17.6641382 10.410046,17.180889 C10.410046,16.6976399 10.0182951,16.305889 9.53504597,16.305889 L3.03504597,16.305889 C2.55179681,16.305889 2.16004597,16.6976399 2.16004597,17.180889 C2.16004597,17.6641382 2.55179681,18.055889 3.03504597,18.055889 Z M13.785046,18.055889 L15.180889,18.055889 C16.7687077,18.055889 18.055889,16.7687077 18.055889,15.180889 L18.055889,13.1381996 C18.055889,12.6549504 17.6641382,12.2631996 17.180889,12.2631996 C16.6976399,12.2631996 16.305889,12.6549504 16.305889,13.1381996 L16.305889,15.180889 C16.305889,15.8022094 15.8022094,16.305889 15.180889,16.305889 L13.785046,16.305889 C13.3017968,16.305889 12.910046,16.6976399 12.910046,17.180889 C12.910046,17.6641382 13.3017968,18.055889 13.785046,18.055889 Z M18.055889,8.88819957 L18.055889,6.65348657 C18.055889,6.17023742 17.6641382,5.77848657 17.180889,5.77848657 C16.6976399,5.77848657 16.305889,6.17023742 16.305889,6.65348657 L16.305889,8.88819957 C16.305889,9.37144872 16.6976399,9.76319957 17.180889,9.76319957 C17.6641382,9.76319957 18.055889,9.37144872 18.055889,8.88819957 Z"
        id="Path-4"
        fill="currentColor"
        fillRule="nonzero"
        transform="translate(6.263701, 11.917188) scale(1, -1) rotate(90.000000) translate(-6.263701, -11.917188) "
      ></path>
    </g>
  </svg>
);

export const ToolCrosshair = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-crosshair"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <g
        id="cursor-target-2"
        transform="translate(3, 3)"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <line
          x1="11"
          y1="-8.8817842e-16"
          x2="11"
          y2="6"
          id="Path"
        ></line>
        <line
          x1="0"
          y1="11"
          x2="6"
          y2="11"
          id="Path"
        ></line>
        <line
          x1="11"
          y1="22"
          x2="11"
          y2="16"
          id="Path"
        ></line>
        <line
          x1="22"
          y1="11"
          x2="16"
          y2="11"
          id="Path"
        ></line>
        <circle
          id="Oval"
          cx="11.001"
          cy="11.001"
          r="2"
        ></circle>
      </g>
    </g>
  </svg>
);

export const ToolDicomTagBrowser = (props: IconProps) => (
  <svg
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      clipRule="evenodd"
      fillRule="evenodd"
    >
      <path
        d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14z"
        fill="transparent"
        stroke="currentColor"
      />
      <path
        transform="translate(-.45)"
        d="M5.904 4.404 2.551 7.758a.34.34 0 0 0 0 .484l3.353 3.354a.34.34 0 0 0 .485 0l.707-.707a.34.34 0 0 0 0-.485L4.69 8l2.405-2.404a.34.34 0 0 0 0-.485l-.707-.707a.34.34 0 0 0-.485 0"
        fill="#db5860"
      />
      <path
        transform="rotate(180 8.225 8)"
        d="M5.904 4.404 2.551 7.758a.34.34 0 0 0 0 .484l3.353 3.354a.34.34 0 0 0 .485 0l.707-.707a.34.34 0 0 0 0-.485L4.69 8l2.405-2.404a.34.34 0 0 0 0-.485l-.707-.707a.34.34 0 0 0-.485 0"
        fill="#db5860"
      />
    </g>
  </svg>
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <g
  //     id="tool-dicom-tag-browser"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     ></rect>
  //     <g
  //       id="Group"
  //       transform="translate(4, 5.5)"
  //       stroke="currentColor"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //       strokeWidth="1.5"
  //     >
  //       <circle
  //         id="Oval"
  //         cx="1.73913043"
  //         cy="1.73913043"
  //         r="1.73913043"
  //       ></circle>
  //       <line
  //         x1="6.95652174"
  //         y1="1.73913043"
  //         x2="20"
  //         y2="1.73913043"
  //         id="Path"
  //       ></line>
  //       <circle
  //         id="Oval"
  //         cx="1.73913043"
  //         cy="8.69565217"
  //         r="1.73913043"
  //       ></circle>
  //       <line
  //         x1="6.95652174"
  //         y1="8.69565217"
  //         x2="20"
  //         y2="8.69565217"
  //         id="Path"
  //       ></line>
  //       <circle
  //         id="Oval"
  //         cx="1.73913043"
  //         cy="15.6521739"
  //         r="1.73913043"
  //       ></circle>
  //       <line
  //         x1="6.95652174"
  //         y1="15.6521739"
  //         x2="20"
  //         y2="15.6521739"
  //         id="Path"
  //       ></line>
  //     </g>
  //   </g>
  // </svg>
);

export const ToolFlipHorizontal = (props: IconProps) => (
  <svg
    width="64"
    height="64"
    viewBox="0 -5 24 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g strokeWidth="0" />
    <g
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V2a.75.75 0 0 1 .75-.75M5.55 3.614l.048.035 1.606 1.146c.287.206.542.387.743.56.217.187.411.396.554.673.142.277.2.556.225.842.024.264.024.577.024.93v8.4c0 .353 0 .666-.024.93a2.2 2.2 0 0 1-.225.842 2.2 2.2 0 0 1-.554.673c-.201.173-.456.355-.743.56L5.55 20.386c-.651.465-1.208.863-1.671 1.1-.473.243-1.074.438-1.68.127-.605-.312-.796-.915-.873-1.44-.076-.516-.076-1.2-.076-2V5.827c0-.8 0-1.483.076-1.999.077-.525.268-1.128.873-1.44.606-.312 1.207-.116 1.68.126.463.238 1.02.636 1.67 1.1m-2.693.115q-.001-.002.013-.002zm.033 0c.044.007.136.033.304.12.353.18.82.51 1.533 1.02L6.307 6c.32.227.518.37.661.493a.8.8 0 0 1 .199.222.8.8 0 0 1 .065.291c.017.188.018.433.018.825v8.34c0 .392 0 .637-.018.825a.8.8 0 0 1-.065.29.8.8 0 0 1-.199.223 10 10 0 0 1-.66.493l-1.581 1.13c-.714.51-1.18.84-1.533 1.02a1.1 1.1 0 0 1-.304.12c-.02-.04-.053-.13-.08-.317-.058-.393-.06-.964-.06-1.84V5.886c0-.876.002-1.448.06-1.84.027-.187.06-.277.08-.317m-.033 16.542.013.002q-.015 0-.013-.002m.043.017.009.01zm0-16.576q.008-.011.009-.01t-.01.01m17.906.136c-.353.181-.82.512-1.533 1.021L17.694 6a10 10 0 0 0-.661.493.8.8 0 0 0-.199.222.8.8 0 0 0-.065.291c-.017.188-.018.433-.018.825v8.34c0 .392 0 .637.018.825a.8.8 0 0 0 .065.29.8.8 0 0 0 .199.223c.143.123.341.266.66.493l1.581 1.13c.714.51 1.18.84 1.533 1.02a1.1 1.1 0 0 0 .304.12 1.1 1.1 0 0 0 .08-.317c.058-.393.06-.964.06-1.84V5.886c0-.876-.002-1.448-.06-1.84a1.1 1.1 0 0 0-.08-.317 1.1 1.1 0 0 0-.304.12m.337-.12h-.013zm-.043-.016-.009-.01.01.01m-.009 16.586.01-.01zm.039-.025q.012-.003.013-.002.001.002-.013.002m-1.009-17.76c.473-.242 1.074-.438 1.68-.126s.796.915.873 1.44c.076.516.076 1.2.076 2v12.347c0 .8 0 1.483-.076 1.999-.077.525-.268 1.128-.873 1.44-.606.311-1.207.116-1.68-.127-.463-.237-1.02-.635-1.67-1.1l-1.655-1.181a11 11 0 0 1-.742-.56 2.2 2.2 0 0 1-.555-.673 2.2 2.2 0 0 1-.225-.842c-.024-.264-.024-.577-.024-.93V7.8c0-.353 0-.666.024-.93.026-.286.083-.565.225-.842s.337-.486.554-.673c.201-.173.456-.354.743-.56l1.654-1.181c.651-.465 1.208-.863 1.671-1.1M12 9.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75m0 8a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75"
      fill="currentColor"
    />
  </svg>
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <g
  //     id="tool-flip-horizontal"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     ></rect>
  //     <path
  //       d="M10.6315789,7.31578947 L6,7.31578947 C4.8954305,7.31578947 4,8.21121997 4,9.31578947 L4,18.5789474 C4,19.6835169 4.8954305,20.5789474 6,20.5789474 L10.6315789,20.5789474 L10.6315789,20.5789474"
  //       id="Path-2"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //     ></path>
  //     <path
  //       d="M25,7.31578947 L20.3684211,7.31578947 C19.2638516,7.31578947 18.3684211,8.21121997 18.3684211,9.31578947 L18.3684211,18.5789474 C18.3684211,19.6835169 19.2638516,20.5789474 20.3684211,20.5789474 L25,20.5789474 L25,20.5789474"
  //       id="Path-2"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeDasharray="1,3.1"
  //       transform="translate(21.6842, 13.9474) scale(-1, 1) translate(-21.6842, -13.9474)"
  //     ></path>
  //     <line
  //       x1="14.5"
  //       y1="4.55263158"
  //       x2="14.5"
  //       y2="23.3421053"
  //       id="Line-3"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //     ></line>
  //   </g>
  // </svg>
);

export const ToolFlipVertical = (props: IconProps) => (
  <svg
    width="64"
    height="64"
    viewBox="-5 0 34 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g strokeWidth="0" />
    <g
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 1.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0V2a.75.75 0 0 1 .75-.75M5.55 3.614l.048.035 1.606 1.146c.287.206.542.387.743.56.217.187.411.396.554.673.142.277.2.556.225.842.024.264.024.577.024.93v8.4c0 .353 0 .666-.024.93a2.2 2.2 0 0 1-.225.842 2.2 2.2 0 0 1-.554.673c-.201.173-.456.355-.743.56L5.55 20.386c-.651.465-1.208.863-1.671 1.1-.473.243-1.074.438-1.68.127-.605-.312-.796-.915-.873-1.44-.076-.516-.076-1.2-.076-2V5.827c0-.8 0-1.483.076-1.999.077-.525.268-1.128.873-1.44.606-.312 1.207-.116 1.68.126.463.238 1.02.636 1.67 1.1m-2.693.115q-.001-.002.013-.002zm.033 0c.044.007.136.033.304.12.353.18.82.51 1.533 1.02L6.307 6c.32.227.518.37.661.493a.8.8 0 0 1 .199.222.8.8 0 0 1 .065.291c.017.188.018.433.018.825v8.34c0 .392 0 .637-.018.825a.8.8 0 0 1-.065.29.8.8 0 0 1-.199.223 10 10 0 0 1-.66.493l-1.581 1.13c-.714.51-1.18.84-1.533 1.02a1.1 1.1 0 0 1-.304.12c-.02-.04-.053-.13-.08-.317-.058-.393-.06-.964-.06-1.84V5.886c0-.876.002-1.448.06-1.84.027-.187.06-.277.08-.317m-.033 16.542.013.002q-.015 0-.013-.002m.043.017.009.01zm0-16.576q.008-.011.009-.01t-.01.01m17.906.136c-.353.181-.82.512-1.533 1.021L17.694 6a10 10 0 0 0-.661.493.8.8 0 0 0-.199.222.8.8 0 0 0-.065.291c-.017.188-.018.433-.018.825v8.34c0 .392 0 .637.018.825a.8.8 0 0 0 .065.29.8.8 0 0 0 .199.223c.143.123.341.266.66.493l1.581 1.13c.714.51 1.18.84 1.533 1.02a1.1 1.1 0 0 0 .304.12 1.1 1.1 0 0 0 .08-.317c.058-.393.06-.964.06-1.84V5.886c0-.876-.002-1.448-.06-1.84a1.1 1.1 0 0 0-.08-.317 1.1 1.1 0 0 0-.304.12m.337-.12h-.013zm-.043-.016-.009-.01.01.01m-.009 16.586.01-.01zm.039-.025q.012-.003.013-.002.001.002-.013.002m-1.009-17.76c.473-.242 1.074-.438 1.68-.126s.796.915.873 1.44c.076.516.076 1.2.076 2v12.347c0 .8 0 1.483-.076 1.999-.077.525-.268 1.128-.873 1.44-.606.311-1.207.116-1.68-.127-.463-.237-1.02-.635-1.67-1.1l-1.655-1.181a11 11 0 0 1-.742-.56 2.2 2.2 0 0 1-.555-.673 2.2 2.2 0 0 1-.225-.842c-.024-.264-.024-.577-.024-.93V7.8c0-.353 0-.666.024-.93.026-.286.083-.565.225-.842s.337-.486.554-.673c.201-.173.456-.354.743-.56l1.654-1.181c.651-.465 1.208-.863 1.671-1.1M12 9.25a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75m0 8a.75.75 0 0 1 .75.75v4a.75.75 0 0 1-1.5 0v-4a.75.75 0 0 1 .75-.75"
      fill="currentColor"
      transform="rotate(90 12 12)"
    />
  </svg>
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <g
  //     id="tool-flip-horizontal"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     ></rect>
  //     <path
  //       d="M10.6315789,7.31578947 L6,7.31578947 C4.8954305,7.31578947 4,8.21121997 4,9.31578947 L4,18.5789474 C4,19.6835169 4.8954305,20.5789474 6,20.5789474 L10.6315789,20.5789474 L10.6315789,20.5789474"
  //       id="Path-2"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //     ></path>
  //     <path
  //       d="M25,7.31578947 L20.3684211,7.31578947 C19.2638516,7.31578947 18.3684211,8.21121997 18.3684211,9.31578947 L18.3684211,18.5789474 C18.3684211,19.6835169 19.2638516,20.5789474 20.3684211,20.5789474 L25,20.5789474 L25,20.5789474"
  //       id="Path-2"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeDasharray="1,3.1"
  //       transform="translate(21.6842, 13.9474) scale(-1, 1) translate(-21.6842, -13.9474)"
  //     ></path>
  //     <line
  //       x1="14.5"
  //       y1="4.55263158"
  //       x2="14.5"
  //       y2="23.3421053"
  //       id="Line-3"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //     ></line>
  //   </g>
  // </svg>
);

export const ToolFreehandPolygon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    {...props}
  >
    <g
      id="icon-freehand-sculpt"
      fill="none"
      strokeWidth="1.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line
        id="svg_1"
        y2="2.559367"
        x2="10.184807"
        y1="4.467781"
        x1="8.81711"
      />
      <line
        id="svg_4"
        y2="1.493836"
        x2="11.727442"
        y1="2.766112"
        x1="10.089386"
      />
      <line
        id="svg_7"
        y2="1.080346"
        x2="13.047428"
        y1="1.748291"
        x1="11.345759"
      />
      <line
        id="svg_8"
        y2="1.000829"
        x2="14.351511"
        y1="1.112153"
        x1="12.77707"
      />
      <line
        id="svg_9"
        y2="1.350705"
        x2="15.242104"
        y1="0.905408"
        x1="13.969828"
      />
      <line
        id="svg_10"
        y2="2.098167"
        x2="15.862339"
        y1="1.14396"
        x1="14.955842"
      />
      <line
        id="svg_11"
        y2="3.195505"
        x2="16.41896"
        y1="1.939133"
        x1="15.766918"
      />
      <line
        id="svg_12"
        y2="4.292843"
        x2="16.530284"
        y1="2.925147"
        x1="16.387153"
      />
      <line
        id="svg_16"
        y2="5.644637"
        x2="16.196311"
        y1="3.831643"
        x1="16.593898"
      />
      <line
        id="svg_18"
        y2="7.266789"
        x2="15.623787"
        y1="5.19934"
        x1="16.275829"
      />
      <line
        id="svg_19"
        y2="10.813258"
        x2="14.526449"
        y1="6.726071"
        x1="15.766918"
      />
      <line
        id="svg_20"
        y2="5.056209"
        x2="8.085552"
        y1="4.181519"
        x1="8.976145"
      />
      <line
        id="svg_23"
        y2="5.326568"
        x2="7.481221"
        y1="4.78585"
        x1="8.403621"
      />
      <line
        id="svg_24"
        y2="5.565119"
        x2="6.749662"
        y1="5.294761"
        x1="7.624352"
      />
      <line
        id="svg_25"
        y2="5.994512"
        x2="5.429675"
        y1="5.533312"
        x1="6.956407"
      />
      <line
        id="svg_27"
        y2="6.551133"
        x2="4.284627"
        y1="5.962706"
        x1="5.572807"
      />
      <line
        id="svg_28"
        y2="7.584858"
        x2="3.044158"
        y1="6.392099"
        x1="4.427758"
      />
      <line
        id="svg_29"
        y2="8.84123"
        x2="2.185372"
        y1="7.489437"
        x1="3.219096"
      />
      <line
        id="svg_31"
        y2="10.606513"
        x2="1.644654"
        y1="8.602678"
        x1="2.280792"
      />
      <line
        id="svg_32"
        y2="13.214679"
        x2="1.48562"
        y1="10.352058"
        x1="1.724171"
      />
      <line
        id="svg_33"
        y2="14.375631"
        x2="1.676461"
        y1="12.992031"
        x1="1.453813"
      />
      <line
        id="svg_34"
        y2="15.298031"
        x2="2.264889"
        y1="14.152983"
        x1="1.517427"
      />
      <line
        id="svg_35"
        y2="16.172721"
        x2="3.521261"
        y1="14.948155"
        x1="1.915013"
      />
      <line
        id="svg_36"
        y2="16.824762"
        x2="5.207027"
        y1="15.997783"
        x1="3.28271"
      />
      <line
        id="svg_38"
        y2="17.063314"
        x2="7.035924"
        y1="16.745245"
        x1="4.968475"
      />
      <line
        id="svg_39"
        y2="16.888376"
        x2="9.278311"
        y1="17.047411"
        x1="6.733758"
      />
      <line
        id="svg_40"
        y2="16.284045"
        x2="10.661911"
        y1="16.983797"
        x1="8.992048"
      />
      <line
        id="svg_41"
        y2="15.313934"
        x2="11.647925"
        y1="16.395369"
        x1="10.455166"
      />
      <line
        id="svg_44"
        y2="13.898527"
        x2="12.82478"
        y1="15.425259"
        x1="11.504794"
      />
      <line
        id="svg_45"
        y2="12.037824"
        x2="14.144766"
        y1="14.312017"
        x1="12.522614"
      />
      <line
        id="svg_47"
        y2="10.59061"
        x2="14.605966"
        y1="12.228665"
        x1="13.953925"
      />
      <ellipse
        ry="1"
        rx="1"
        id="svg_48"
        cy="3.982726"
        cx="13.460918"
      />
    </g>
  </svg>
);

export const ToolFreehandRoi = (props: IconProps) => (
  <svg
    width="256"
    height="256"
    viewBox="-3 -3 28 28"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    stroke="#fff"
    strokeWidth="0"
    {...props}
  >
    <g />
    <g
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="#CCC"
      strokeWidth=".048"
    />
    <path
      d="M21.8 15.66c0 3.479-1.17 6.14-4.553 6.14-3.743 0-5.414-2.337-8.7-2.337-.844 0-1.535.154-2.22.154A4.14 4.14 0 0 1 2 15.504c0-2.329 2.956-2.756 3.19-7.521C5.373 4.254 8.23 2.2 11.565 2.2 17.521 2.2 21.8 8.757 21.8 15.66m-1 0c0-6.017-3.711-12.46-9.235-12.46-2.37 0-5.2 1.265-5.376 4.832a8.82 8.82 0 0 1-2.272 5.716C3.314 14.493 3 14.91 3 15.504c0 3.077 3.293 3.113 3.326 3.113a9 9 0 0 0 .89-.066 12 12 0 0 1 1.33-.088 10.3 10.3 0 0 1 4.465 1.2 9.6 9.6 0 0 0 4.235 1.137c.879 0 3.554 0 3.554-5.14"
      stroke="none"
    />
    <path
      opacity=".25"
      d="M17.246 20.8a9.6 9.6 0 0 1-4.235-1.137 10.3 10.3 0 0 0-4.464-1.2 12 12 0 0 0-1.331.088 9 9 0 0 1-.89.066C6.293 18.617 3 18.58 3 15.504c0-.594.314-1.01.917-1.756a8.82 8.82 0 0 0 2.272-5.716C6.364 4.465 9.194 3.2 11.565 3.2c5.524 0 9.235 6.443 9.235 12.46 0 5.14-2.675 5.14-3.554 5.14"
      stroke="none"
    />
    <path
      fill="none"
      d="M0 0h24v24H0z"
      stroke="none"
    />
  </svg>
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <g
  //     id="tool-freehand-roi"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     ></rect>
  //     <g
  //       id="Group-2"
  //       transform="translate(3, 2)"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //     >
  //       <path
  //         d="M0,0 C8,3 5,8.5 2,15.5 C-1,22.5 3.5,23 5,23 C6.08963707,23.0518834 7.15942037,22.6952889 8,22"
  //         id="Path"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       ></path>
  //       <path
  //         d="M21.38,12.619 L13.75,20.25 L10,21 L10.75,17.25 L18.38,9.619 C19.2062949,8.79296781 20.5457051,8.79296781 21.372,9.619 L21.38,9.628 C21.7771113,10.0243763 22.000268,10.5624193 22.000268,11.1235 C22.000268,11.6845807 21.7771113,12.2226237 21.38,12.619 L21.38,12.619 Z"
  //         id="Path"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       ></path>
  //       <path
  //         d="M10.654274,17.2961006 C11.6738332,18.1907082 12.6933924,19.0853157 13.7129517,19.9799232"
  //         id="Path-4"
  //       ></path>
  //     </g>
  //   </g>
  // </svg>
);

export const ToolFreehand = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    {...props}
  >
    <g
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="miter"
    >
      <ellipse
        ry="1"
        rx="1"
        id="svg_3"
        cy="4.240343"
        cx="14.306499"
      />
      <line
        id="svg_4"
        y2="3.58462"
        x2="12.242186"
        y1="3.997482"
        x1="13.432202"
      />
      <line
        id="svg_5"
        y2="3.268901"
        x2="10.857882"
        y1="3.608906"
        x1="12.387902"
      />
      <line
        id="svg_6"
        y2="3.147471"
        x2="9.740724"
        y1="3.293187"
        x1="10.955026"
      />
      <line
        id="svg_7"
        y2="3.147471"
        x2="8.089274"
        y1="3.196043"
        x1="9.983585"
      />
      <line
        id="svg_8"
        y2="3.268901"
        x2="6.874972"
        y1="3.123185"
        x1="8.307848"
      />
      <line
        id="svg_9"
        y2="3.657478"
        x2="5.587812"
        y1="3.220329"
        x1="7.020688"
      />
      <line
        id="svg_10"
        y2="4.046054"
        x2="4.737801"
        y1="3.560334"
        x1="5.854959"
      />
      <line
        id="svg_11"
        y2="4.337487"
        x2="4.300652"
        y1="3.997482"
        x1="4.834945"
      />
      <line
        id="svg_12"
        y2="4.726063"
        x2="3.88779"
        y1="4.191771"
        x1="4.470655"
      />
      <line
        id="svg_15"
        y2="5.3575"
        x2="3.377783"
        y1="4.604633"
        x1="3.960648"
      />
      <line
        id="svg_16"
        y2="6.183226"
        x2="2.916348"
        y1="5.138926"
        x1="3.547785"
      />
      <line
        id="svg_17"
        y2="6.960379"
        x2="2.770632"
        y1="5.867507"
        x1="3.037779"
      />
      <line
        id="svg_18"
        y2="7.713246"
        x2="2.673488"
        y1="6.741804"
        x1="2.819204"
      />
      <line
        id="svg_19"
        y2="8.684687"
        x2="2.697774"
        y1="7.616102"
        x1="2.673488"
      />
      <line
        id="svg_20"
        y2="9.753273"
        x2="2.892062"
        y1="8.611829"
        x1="2.697774"
      />
      <line
        id="svg_21"
        y2="10.724714"
        x2="3.134923"
        y1="9.534698"
        x1="2.84349"
      />
      <line
        id="svg_23"
        y2="11.647583"
        x2="3.596357"
        y1="10.578998"
        x1="3.086351"
      />
      <line
        id="svg_25"
        y2="12.521881"
        x2="4.276366"
        y1="11.501867"
        x1="3.499213"
      />
      <line
        id="svg_26"
        y2="13.930471"
        x2="5.830673"
        y1="12.376165"
        x1="4.13065"
      />
      <line
        id="svg_28"
        y2="14.707624"
        x2="7.263549"
        y1="13.881899"
        x1="5.733528"
      />
      <line
        id="svg_29"
        y2="15.339061"
        x2="8.963571"
        y1="14.61048"
        x1="7.06926"
      />
      <line
        id="svg_30"
        y2="15.581921"
        x2="10.882168"
        y1="15.314775"
        x1="8.817855"
      />
      <line
        id="svg_31"
        y2="15.460491"
        x2="12.023612"
        y1="15.581921"
        x1="10.785024"
      />
      <line
        id="svg_33"
        y2="15.120487"
        x2="13.092197"
        y1="15.484777"
        x1="11.877895"
      />
      <line
        id="svg_34"
        y2="14.586194"
        x2="13.86935"
        y1="15.217631"
        x1="12.897909"
      />
      <line
        id="svg_35"
        y2="13.833327"
        x2="14.597931"
        y1="14.756196"
        x1="13.699348"
      />
      <line
        id="svg_37"
        y2="12.716169"
        x2="15.180796"
        y1="13.881899"
        x1="14.549359"
      />
      <line
        id="svg_39"
        y2="11.429009"
        x2="15.520801"
        y1="12.813313"
        x1="15.15651"
      />
      <ellipse
        ry="1"
        rx="1"
        id="svg_40"
        cy="10.967574"
        cx="15.520801"
      />
    </g>
  </svg>
);

export const ToolFusionColor = (props: IconProps) => (
  <svg
    width="25px"
    height="25px"
    viewBox="0 0 25 25"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      stroke="currentColor"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M18,2 C19.1045695,2 20,2.8954305 20,4 L20.000443,11.5700239 C18.8210504,10.0206853 17.6279451,8.77097591 17.1182222,8.25530435 C16.9570959,8.09231818 16.733654,8.00006956 16.5,8.00006956 C16.266346,8.00006956 16.0429041,8.09231818 15.8817778,8.25530435 C14.719,9.43165217 10,14.4278261 10,18.0869565 C10,18.7674866 10.1126915,19.4091677 10.3210825,20.0009348 L4,20 C2.8954305,20 2,19.1045695 2,18 L2,4 C2,2.8954305 2.8954305,2 4,2 L18,2 Z"
        id="Combined-Shape"
        stroke="currentColor"
        strokeWidth="1.75"
      ></path>
      <g
        id="color-drop-pick"
        transform="translate(9.591386, 8.000070)"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path
          d="M7.52683573,0.255234787 C7.36570938,0.0922486197 7.14226748,0 6.90861351,0 C6.67495954,0 6.45151764,0.0922486197 6.29039129,0.255234787 C5.12761351,1.43158261 0.408613509,6.42775653 0.408613509,10.086887 C0.408613509,13.5449739 3.31844684,15.9999304 6.90861351,15.9999304 C10.4987802,15.9999304 13.4086135,13.5449739 13.4086135,10.086887 C13.4086135,6.42775653 8.68961351,1.43158261 7.52683573,0.255234787 Z"
          id="Path"
          strokeWidth="1.75"
        ></path>
        <g
          id="Group"
          transform="translate(7.015298, 8.975291) rotate(40.000000) translate(-7.015298, -8.975291) translate(3.731654, 1.974720)"
        >
          <line
            x1="0.5"
            y1="12.5"
            x2="0.5"
            y2="1.56125113e-15"
            id="Path"
          ></line>
          <line
            x1="3.420153"
            y1="1.25018584"
            x2="3.420153"
            y2="14.0011428"
            id="Path"
          ></line>
          <line
            x1="6.06728889"
            y1="1.86765717"
            x2="6.06728889"
            y2="12.7034832"
            id="Path"
          ></line>
        </g>
      </g>
    </g>
  </svg>
);

export const ToolInvert = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 450.16 500.16"
    {...props}
  >
    <path d="M326.72 120.747 206.08 0 85.44 120.747c-66.667 66.667-66.667 174.72 0 241.387 33.28 33.28 77.013 50.027 120.64 50.027s87.36-16.64 120.64-50.027c66.667-66.667 66.667-174.721 0-241.387m-120.64 248.64c-34.24 0-66.347-13.333-90.453-37.547-24.213-24.107-37.547-56.213-37.547-90.453s13.333-66.347 37.547-90.56l90.453-90.453z" />
  </svg>
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <g
  //     id="tool-invert"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     ></rect>
  //     <rect
  //       id="Rectangle"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       x="4"
  //       y="5"
  //       width="20"
  //       height="18"
  //       rx="2"
  //     ></rect>
  //     <path
  //       d="M14,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,7 C4,5.8954305 4.8954305,5 6,5 L14,5 L14,8 C10.6862915,8 8,10.6862915 8,14 C8,17.3137085 10.6862915,20 14,20 L14,23 Z"
  //       id="Combined-Shape"
  //       fill="currentColor"
  //     ></path>
  //     <path
  //       d="M14,8 C17.3137085,8 20,10.6862915 20,14 C20,17.3137085 17.3137085,20 14,20 Z"
  //       id="Combined-Shape"
  //       fill="currentColor"
  //     ></path>
  //   </g>
  // </svg>
);

export const ToolLayoutDefault = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-layout"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <g
        id="Group"
        transform="translate(0.5, 4)"
        strokeLinecap="round"
      >
        <g
          id="Group-3"
          transform="translate(0, 0)"
          stroke="currentColor"
          strokeWidth="1.25"
        >
          <path
            d="M5.45696821e-12,9.49450549 L5.45696821e-12,17.3947362 C5.45710348e-12,18.4993057 0.8954305,19.3947362 2,19.3947362 L13.2443085,19.3947362 L13.2443085,19.3947362"
            id="Path-3"
          ></path>
          <path
            d="M9.49450549,0 L9.49450549,4.91369247 L9.49450549,6 C9.49450549,7.1045695 10.389936,8 11.4945055,8 L19.195248,8 L19.195248,8"
            id="Path-3"
            transform="translate(14.3449, 4) rotate(180) translate(-14.3449, -4)"
          ></path>
          <path
            d="M0.0997440877,-0.0997440877 L0.0997440877,7.80048659 C0.0997440877,8.90505609 0.995174588,9.80048659 2.09974409,9.80048659 L9.80048659,9.80048659 L9.80048659,9.80048659"
            id="Path-3"
            transform="translate(4.9501, 4.8504) rotate(90) translate(-4.9501, -4.8504)"
          ></path>
        </g>
        <g
          id="Group-10"
          opacity="0.550000012"
          transform="translate(2, 2)"
          stroke="currentColor"
          strokeWidth="1.5"
        >
          <line
            x1="7.5"
            y1="14.5"
            x2="7.5"
            y2="0.5"
            id="Line-2"
          ></line>
          <line
            x1="7"
            y1="14"
            x2="7"
            y2="1"
            id="Line-2"
            transform="translate(7, 7.5) rotate(90) translate(-7, -7.5)"
          ></line>
        </g>
        <g
          id="gear"
          transform="translate(21.0876, 17.2796) rotate(-20) translate(-21.0876, -17.2796)translate(15.9634, 11.5127)"
          stroke="#348CFD"
          strokeLinejoin="round"
          strokeWidth="1.25"
        >
          <circle
            id="Oval"
            cx="5.12378058"
            cy="5.76719178"
            r="1.28158482"
          ></circle>
          <path
            d="M6.21361819,0.80762797 L6.59086967,2.04907966 C6.72061095,2.47639719 7.15892721,2.73042581 7.59419808,2.63056421 L8.85259487,2.33893009 C9.34216301,2.22858155 9.84650092,2.45011894 10.0964357,2.88530436 C10.3463705,3.32048979 10.2835655,3.86774756 9.94154064,4.23499782 L9.06128718,5.18481538 C8.75980718,5.51248709 8.75980718,6.0165454 9.06128718,6.3442171 L9.94154064,7.29403466 C10.2835655,7.66128493 10.3463705,8.2085427 10.0964357,8.64372812 C9.84650092,9.07891354 9.34216301,9.30045094 8.85259487,9.1901024 L7.59419808,8.89846827 C7.15663131,8.79632613 6.71524652,9.05279063 6.58730228,9.48352022 L6.2100508,10.7249719 C6.0649735,11.2053044 5.62242271,11.5339347 5.12065911,11.5339347 C4.61889551,11.5339347 4.17634472,11.2053044 4.03126742,10.7249719 L3.65669148,9.48352022 C3.52807698,9.05567912 3.08963152,8.80095947 2.65425492,8.90114382 L1.39585813,9.19277794 C0.90628999,9.30312648 0.401952083,9.08158909 0.152017275,8.64640366 C-0.0979175321,8.21121824 -0.035112502,7.66396047 0.306912358,7.29671021 L1.18716582,6.34689264 C1.48864582,6.01922094 1.48864582,5.51516263 1.18716582,5.18749093 L0.306912358,4.23767336 C-0.035112502,3.8704231 -0.0979175321,3.32316533 0.152017275,2.88797991 C0.401952083,2.45279448 0.90628999,2.23125709 1.39585813,2.34160563 L2.65425492,2.63323975 C3.08937078,2.73350334 3.52770594,2.47923776 3.65669148,2.0517552 L4.03483481,0.810303513 C4.17932126,0.32979188 4.62146882,0.000617032116 5.12323309,0 C5.62499736,-0.000615299293 6.06795204,0.327472644 6.21361819,0.80762797 Z"
            id="Path"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export const ToolMagneticRoi = (props: IconProps) => (
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <g
  //     id="tool-livewire"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     ></rect>
  //     <line
  //       x1="12.5"
  //       y1="6.5"
  //       x2="8.5"
  //       y2="9.5"
  //       id="Line"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="square"
  //     ></line>
  //     <line
  //       x1="6.5"
  //       y1="12.5"
  //       x2="5.5"
  //       y2="19.5"
  //       id="Line"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="square"
  //     ></line>
  //     <g
  //       id="Group"
  //       transform="translate(16.998, 17.5912) rotate(45) translate(-16.998, -17.5912)translate(12.496, 13.5)"
  //       stroke="currentColor"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //       strokeWidth="1.5"
  //     >
  //       <line
  //         x1="0.00327299164"
  //         y1="2.45474373"
  //         x2="3.27626463"
  //         y2="2.45474373"
  //         id="Path"
  //       ></line>
  //       <line
  //         x1="5.73100836"
  //         y1="2.45474373"
  //         x2="9.004"
  //         y2="2.45474373"
  //         id="Path"
  //       ></line>
  //       <path
  //         d="M5.72773537,4.09123955 C5.72773537,4.76909831 5.17822227,5.31861141 4.5003635,5.31861141 C3.82250474,5.31861141 3.27299164,4.76909831 3.27299164,4.09123955 L3.27299164,0.81824791 C3.25976214,0.371936739 2.9010549,0.0132295012 2.45474373,-5.11613498e-14 L0.81824791,-5.11613498e-14 C0.371936739,0.0132295012 0.0132295012,0.371936739 0,0.81824791 L0,4.09123955 C0,6.80209487 2.01452635,8.1824791 4.5003635,8.1824791 C6.98620065,8.1824791 9.00072701,6.80209487 9.00072701,4.09123955 L9.00072701,0.81824791 C8.98749751,0.371936739 8.62879027,0.0132295012 8.1824791,-5.11613498e-14 L6.54598328,-5.11613498e-14 C6.09967211,0.0132295012 5.74096487,0.371936739 5.72773537,0.81824791 L5.72773537,4.09123955 Z"
  //         id="Path"
  //       ></path>
  //     </g>
  //     <circle
  //       id="Oval"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //       cx="14.5"
  //       cy="5.5"
  //       r="1.5"
  //     ></circle>
  //     <circle
  //       id="Oval"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //       cx="5.5"
  //       cy="21.5"
  //       r="1.5"
  //     ></circle>
  //     <circle
  //       id="Oval"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //       cx="7"
  //       cy="10.5"
  //       r="1.5"
  //     ></circle>
  //   </g>
  // </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="transparent"
    viewBox="0 0 512 270"
    {...props}
  >
    <path d="M512 257.05v12.92H0v-270h236.53c-11.47 5.07-11.68 15.23-10.89 25.72H83.4c-6-12-14.61-16.74-25.42-14.23A20.36 20.36 0 0 0 41.92 31.6c-.08 10.21 6.27 18.38 16.06 20.65 10.8 2.5 19.34-2.26 25.38-14.13h91.91c-36.82 14.72-68.72 36.18-94.39 66.44a233.1 233.1 0 0 0-51 103.65c-4.66 0-9.14-.08-13.61 0-8.79.18-14.91 5.78-15.15 14.45q-.43 15.93 0 31.88c.23 8.35 5.74 14.1 13.59 14.29q16.71.4 33.43 0c8.22-.2 13.42-5.36 13.63-13.55.29-11.11.14-22.24.05-33.37-.06-6.34-5.61-14.23-14.11-13.73a50 50 0 0 1-5.28-.24q16.93-71 71.07-118.36c32-28 69.45-44.62 112.1-50.94 0 2.87-.11 5.17 0 7.47.43 7.83 6.68 14.41 14.21 14.53 11.14.19 22.28.07 33.43 0 4.46 0 8.56-1.55 10.41-5.6 2.26-5 3.54-10.34 5.46-16.22 47.06 7.13 88.59 27.58 122.77 62.36 29.46 30 49 65.44 58.68 107h-3.3c-11.29.34-16.08 5.12-16.13 16.26 0 10-.14 19.93 0 29.89.17 9.13 5.63 14.47 14.74 14.59s18-.28 26.94.12c9.43.46 16.2-2.58 19.19-11.99m-201.39-87.21a19 19 0 0 0-1-3c-15.63-31.27-31.24-62.55-47.07-93.72-1-2-3.89-4.42-5.68-4.26-2.19.2-5 2.5-6.06 4.63-16 31.1-31.63 62.34-47.5 93.49-1.57 3.08-1.65 5.65.59 8.18s4.85 2 7.7.85c13.61-5.7 27.22-11.4 41-16.78a11.76 11.76 0 0 1 7.79-.08c13.9 5.44 27.63 11.27 41.44 16.94 4.86 2.04 8.88-.47 8.79-6.25" />
    <path d="M276.46-.03H512v220.22c-3-9.76-9.88-13-19.51-12a89 89 0 0 1-8.93 0c-20.24-81.52-68.08-138.56-147-170.18h93.16c.49 1 .9 1.95 1.34 2.84a20.81 20.81 0 0 0 24.12 11.34 20.3 20.3 0 0 0 15.88-20.22c0-10-6.15-18-15.72-20.38-10-2.47-19.75 1.8-24.1 11.18-1.38 3-3.13 3.17-5.74 3.17q-66.35-.08-132.7 0h-5.51c.64-10.97.93-21.13-10.83-25.97" />
    <path
      fill="currentColor"
      d="M276.46-.03c11.76 4.81 11.47 14.94 10.83 25.91H425.5c2.61 0 4.36-.18 5.74-3.17 4.35-9.38 14.08-13.65 24.1-11.18 9.57 2.44 15.78 10.44 15.72 20.44a20.3 20.3 0 0 1-15.88 20.26 20.81 20.81 0 0 1-24.12-11.34c-.44-.89-.85-1.8-1.34-2.84h-93.15c78.91 31.62 126.75 88.66 147 170.18a89 89 0 0 0 8.93 0c9.63-.94 16.56 2.25 19.51 12v36.86c-3 9.41-9.76 12.45-19.15 12-9-.4-18 0-26.94-.12s-14.57-5.46-14.74-14.59c-.18-10-.09-19.93 0-29.89 0-11.14 4.84-15.92 16.13-16.26h3.3c-9.64-41.52-29.22-77-58.68-107C377.75 66.45 336.22 46 289.16 38.87c-1.92 5.88-3.2 11.27-5.46 16.22-1.85 4-5.95 5.59-10.41 5.6-11.15 0-22.29.15-33.43 0-7.53-.12-13.78-6.7-14.21-14.53-.13-2.3 0-4.6 0-7.47-42.65 6.32-80.07 22.9-112.1 50.94q-54.32 47.52-71.14 118.34a50 50 0 0 0 5.28.24c8.5-.5 14.05 7.39 14.11 13.73.09 11.13.24 22.26-.05 33.37-.21 8.19-5.41 13.35-13.63 13.55q-16.69.42-33.43 0c-7.85-.19-13.36-5.94-13.59-14.29q-.47-15.93 0-31.88c.24-8.67 6.36-14.27 15.15-14.45 4.47-.1 8.95 0 13.61 0a233.1 233.1 0 0 1 51-103.65c25.67-30.26 57.57-51.72 94.39-66.44H83.36c-6 11.87-14.58 16.63-25.38 14.13-9.79-2.27-16.14-10.44-16.06-20.65a20.36 20.36 0 0 1 16.06-20.14c10.81-2.51 19.37 2.27 25.42 14.23h142.24c-.79-10.49-.58-20.65 10.89-25.72Zm-20 12h-14.44c-3.07 0-4.54 1.38-4.52 4.52.05 9.28 0 18.56 0 27.84 0 3.07 1.38 4.53 4.53 4.52q14.44-.09 28.89 0c3.15 0 4.52-1.47 4.51-4.53V16.48c0-3.07-1.39-4.56-4.54-4.52-4.77.01-9.59.01-14.41.01ZM49.9 238.82c0-4.8-.17-9.61.05-14.41.16-3.34-1.21-4.31-4.35-4.27q-14.19.2-28.37 0c-3 0-4.29 1-4.27 4q.07 14.4 0 28.81c0 3 1.29 4.16 4.21 4.14q14.19-.11 28.37 0c3.08 0 4.57-1 4.42-4.34-.22-4.65-.06-9.29-.06-13.93m431.72-18.63c-4.65 0-9.3.15-13.94-.06-3.31-.15-4.76.71-4.67 4.39.24 9.44.16 18.89 0 28.33 0 2.87.75 4.27 3.88 4.23 9.63-.11 19.25 0 28.88 0 2.8 0 4.27-1.16 4.24-4.17q-.12-14.17 0-28.34c0-3.21-1.34-4.46-4.49-4.37-4.6.08-9.25-.01-13.9-.01M63.12 22.97c-5.87-.1-9.06 2.88-9.15 8.54-.08 5.37 3.53 9.22 8.76 9.33s9-3.6 9.14-8.94c.07-5.74-2.99-8.86-8.75-8.93m387 0c-5.78 0-8.94 3.14-8.89 8.79 0 5.35 3.77 9.11 9 9.08s8.91-3.84 8.89-9.19c-.08-5.75-3.17-8.68-9.06-8.68Z"
    />
    <path
      fill="currentColor"
      d="M310.61 169.84c.09 5.78-3.93 8.29-8.88 6.26-13.81-5.67-27.54-11.5-41.44-16.94a11.76 11.76 0 0 0-7.79.08c-13.74 5.38-27.35 11.08-41 16.78-2.85 1.19-5.45 1.72-7.7-.85s-2.16-5.1-.59-8.18c15.87-31.15 31.54-62.39 47.5-93.49 1.09-2.13 3.87-4.43 6.06-4.63 1.79-.16 4.67 2.27 5.68 4.26 15.83 31.17 31.44 62.45 47.07 93.72a19.3 19.3 0 0 1 1.09 2.99M256.5 87.67c-12.08 24.12-23.62 47.18-35.16 70.24a214 214 0 0 0 28.16-10.81 14.19 14.19 0 0 1 13.11-.09c9.25 4.25 18.82 7.82 29.73 12.28-12.22-24.39-23.72-47.39-35.84-71.62"
    />
    <path d="M256.48 11.97c4.82 0 9.63.05 14.44 0 3.15 0 4.55 1.45 4.54 4.52v27.84c0 3.06-1.36 4.55-4.51 4.53q-14.45-.08-28.89 0c-3.15 0-4.54-1.45-4.53-4.52V16.5c0-3.14 1.45-4.54 4.52-4.52 4.81-.01 9.62-.01 14.43-.01M49.9 238.82c0 4.64-.16 9.28.05 13.91.15 3.34-1.34 4.37-4.42 4.34q-14.18-.11-28.37 0c-2.92 0-4.23-1.17-4.21-4.14q.1-14.4 0-28.81c0-3 1.31-4 4.27-4q14.17.2 28.37 0c3.14 0 4.51.93 4.35 4.27-.21 4.82-.04 9.63-.04 14.43m431.72-18.63c4.65 0 9.3.09 13.94 0 3.15-.09 4.52 1.16 4.49 4.37q-.15 14.18 0 28.34c0 3-1.44 4.17-4.24 4.17-9.63 0-19.25-.07-28.88 0-3.13 0-3.91-1.36-3.88-4.23.13-9.44.21-18.89 0-28.33-.09-3.68 1.36-4.54 4.67-4.39 4.6.22 9.25.07 13.9.07M63.12 22.97c5.81.09 8.87 3.21 8.75 8.93-.11 5.34-3.89 9-9.14 8.94s-8.84-4-8.76-9.33c.04-5.68 3.23-8.66 9.15-8.54m386.94 0c5.89 0 9 2.95 9 8.68 0 5.35-3.66 9.16-8.89 9.19s-9-3.73-9-9.08c-.05-5.67 3.11-8.79 8.89-8.79M256.5 87.67c12.12 24.23 23.63 47.23 35.84 71.62-10.91-4.46-20.48-8-29.73-12.28a14.19 14.19 0 0 0-13.11.09 214 214 0 0 1-28.16 10.81c11.54-23.06 23.08-46.12 35.16-70.24" />
  </svg>
);

export const ToolMagnify = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-zoom-in"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <circle
        id="Oval"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        cx="12.75"
        cy="12.7491667"
        r="8.33333333"
      ></circle>
      <line
        x1="23.5833333"
        y1="23.5825"
        x2="18.6425"
        y2="18.6416667"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
      <line
        x1="8.58333333"
        y1="12.7491667"
        x2="16.9166667"
        y2="12.7491667"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
      <line
        x1="12.75"
        y1="8.5825"
        x2="12.75"
        y2="16.9158333"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
    </g>
  </svg>
);

export const ToolMeasureEllipse = (props: IconProps) => (
  <svg
    height="200"
    width="200"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-40 -50 612 612"
    {...props}
  >
    <g strokeWidth="0" />
    <g
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M503.47 231.292h-19.628c-22.657-62.638-105.58-108.515-210.691-116.371V94.806a8.533 8.533 0 0 0-8.53-8.53h-51.182a8.533 8.533 0 0 0-8.53 8.53v21.138C87.138 128.714 0 193.264 0 269.678c0 86.046 111.014 156.046 247.465 156.046 127.776 0 221.943-50.389 237.766-126.189h18.238a8.533 8.533 0 0 0 8.53-8.53v-51.182a8.526 8.526 0 0 0-8.529-8.531M221.968 103.337h34.121v34.121h-34.121zm25.497 305.326c-127.051 0-230.405-62.348-230.405-138.985 0-67.236 79.742-124.355 187.847-136.571v12.881a8.533 8.533 0 0 0 8.53 8.53h51.182a8.533 8.533 0 0 0 8.53-8.53v-13.964c94.508 7.328 169.336 46.072 192.556 99.268h-13.41a8.533 8.533 0 0 0-8.53 8.53v51.182a8.533 8.533 0 0 0 8.53 8.53h15.235c-16.505 64.712-104.709 109.129-220.065 109.129m247.474-126.189h-34.121v-34.121h34.121z" />
    <path d="M256.09 256.883h-8.53v-8.53a8.527 8.527 0 0 0-8.53-8.53 8.533 8.533 0 0 0-8.53 8.53v8.53h-8.53a8.533 8.533 0 0 0-8.53 8.53 8.533 8.533 0 0 0 8.53 8.53h8.53v8.53c0 4.709 3.822 8.53 8.53 8.53s8.53-3.822 8.53-8.53v-8.53h8.53a8.533 8.533 0 0 0 8.53-8.53 8.533 8.533 0 0 0-8.53-8.53" />
  </svg>
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <g
  //     id="tool-measure-elipse"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     ></rect>
  //     <g
  //       id="Group"
  //       transform="translate(1.6119, 2.6735)"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //     >
  //       <line
  //         x1="19.8333333"
  //         y1="14.625"
  //         x2="19.8333333"
  //         y2="22.9583333"
  //         id="Path"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       ></line>
  //       <line
  //         x1="24"
  //         y1="18.7916667"
  //         x2="15.6666667"
  //         y2="18.7916667"
  //         id="Path"
  //         strokeLinecap="round"
  //         strokeLinejoin="round"
  //       ></line>
  //       <ellipse
  //         id="Oval"
  //         transform="translate(10.5, 7) rotate(89) translate(-10.5, -7)"
  //         cx="10.5"
  //         cy="7"
  //         rx="6.5"
  //         ry="10"
  //       ></ellipse>
  //     </g>
  //   </g>
  // </svg>
);

export const ToolMoreMenu = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 6"
    {...props}
  >
    <g
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M0 0L29 0 29 29 0 29z"
        transform="translate(-4.5 -11.5)"
      />
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M7.25 12.083c-1.33 0-2.417 1.088-2.417 2.417 0 1.33 1.088 2.417 2.417 2.417 1.33 0 2.417-1.088 2.417-2.417 0-1.33-1.088-2.417-2.417-2.417zm14.5 0c-1.33 0-2.417 1.088-2.417 2.417 0 1.33 1.088 2.417 2.417 2.417 1.33 0 2.417-1.088 2.417-2.417 0-1.33-1.088-2.417-2.417-2.417zm-7.25 0c-1.33 0-2.417 1.088-2.417 2.417 0 1.33 1.088 2.417 2.417 2.417 1.33 0 2.417-1.088 2.417-2.417 0-1.33-1.088-2.417-2.417-2.417z"
        transform="translate(-4.5 -11.5)"
      />
    </g>
  </svg>
);

export const ToolMove = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-move"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <line
        x1="13.8823529"
        y1="22.5294118"
        x2="13.8823529"
        y2="4"
        id="Line"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
      <line
        x1="22.5294118"
        y1="13.8823529"
        x2="5.23529412"
        y2="13.8823529"
        id="Line"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
      <polyline
        id="Path-28"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        points="11.4117647 6.46832349 13.8800882 4 16.3642969 6.48420875"
      ></polyline>
      <polyline
        id="Path-28"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(13.888, 22.5362) rotate(-180) translate(-13.888, -22.5362)"
        points="11.4117647 23.7624411 13.8800882 21.2941176 16.3642969 23.7783264"
      ></polyline>
      <polyline
        id="Path-28"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(5.2421, 13.888) rotate(-90) translate(-5.2421, -13.888)"
        points="2.76583826 15.1142499 5.23416174 12.6459264 7.71837049 15.1301352"
      ></polyline>
      <polyline
        id="Path-28"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(22.5362, 13.888) rotate(-270) translate(-22.5362, -13.888)"
        points="20.0599559 15.1142499 22.5282794 12.6459264 25.0124881 15.1301352"
      ></polyline>
    </g>
  </svg>
);

export const ToolPolygon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 50 50"
    {...props}
  >
    <polygon
      points="24 1, 46 18, 40 49, 9 49, 1 18"
      stroke="currentColor"
      strokeWidth="3"
      fill="none"
    />
  </svg>
);

export const ToolQuickMagnify = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-zoom-in"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <circle
        id="Oval"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        cx="12.75"
        cy="12.7491667"
        r="8.33333333"
      ></circle>
      <line
        x1="23.5833333"
        y1="23.5825"
        x2="18.6425"
        y2="18.6416667"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
      <line
        x1="8.58333333"
        y1="12.7491667"
        x2="16.9166667"
        y2="12.7491667"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
      <line
        x1="12.75"
        y1="8.5825"
        x2="12.75"
        y2="16.9158333"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
    </g>
  </svg>
);

export const ToolRectangle = (props: IconProps) => (
  <svg
    height="64"
    width="64"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-70 -50 700 600"
    fill="currentColor"
    {...props}
  >
    <g strokeWidth="0" />
    <g
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M503.467 72.533h-51.2a8.536 8.536 0 0 0-8.533 8.533v17.067H29.867A4.27 4.27 0 0 0 25.6 102.4v268.8H8.533A8.536 8.536 0 0 0 0 379.733v51.2a8.536 8.536 0 0 0 8.533 8.533h51.2a8.536 8.536 0 0 0 8.533-8.533v-17.067h413.867a4.27 4.27 0 0 0 4.267-4.267V140.8h17.067a8.536 8.536 0 0 0 8.533-8.533v-51.2c0-4.711-3.823-8.534-8.533-8.534M51.2 422.4H17.067v-34.133H51.2zm418.133-25.6H68.267v-17.067a8.536 8.536 0 0 0-8.533-8.533H42.667v-256h401.067v17.067a8.536 8.536 0 0 0 8.533 8.533h17.067v256zm25.6-273.067H460.8V89.6h34.133z" />
  </svg>
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <g
  //     id="tool-rectangle"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     ></rect>
  //     <g
  //       id="Group-8"
  //       transform="translate(15.8182, 15.5)"
  //       stroke="currentColor"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //       strokeWidth="1.65"
  //     >
  //       <line
  //         x1="3.78787879"
  //         y1="1.69561335e-14"
  //         x2="3.78787879"
  //         y2="7.57575758"
  //         id="Path"
  //       ></line>
  //       <line
  //         x1="7.57575758"
  //         y1="3.78787879"
  //         x2="-1.37263938e-13"
  //         y2="3.78787879"
  //         id="Path"
  //       ></line>
  //     </g>
  //     <path
  //       d="M12.030303,19.2878788 L6,19.2878788 C4.8954305,19.2878788 4,18.3924483 4,17.2878788 L4,7.5 C4,6.3954305 4.8954305,5.5 6,5.5 L19.8924006,5.5 C20.9969701,5.5 21.8924006,6.3954305 21.8924006,7.5 L21.8924006,12.0059038 L21.8924006,12.0059038"
  //       id="Path-5"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //     ></path>
  //   </g>
  // </svg>
);

export const ToolReferenceLines = (props: IconProps) => (
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <g
  //     id="tool-reference-lines"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     ></rect>
  //     <path
  //       d="M5.75,14.75 L7.75,14.75 C8.16421356,14.75 8.5,14.4142136 8.5,14 C8.5,13.5857864 8.16421356,13.25 7.75,13.25 L5.75,13.25 C5.33578644,13.25 5,13.5857864 5,14 C5,14.4142136 5.33578644,14.75 5.75,14.75 Z"
  //       id="Path"
  //       fill="currentColor"
  //       fillRule="nonzero"
  //     ></path>
  //     <path
  //       d="M10.75,14.75 L12.75,14.75 C13.1642136,14.75 13.5,14.4142136 13.5,14 C13.5,13.5857864 13.1642136,13.25 12.75,13.25 L10.75,13.25 C10.3357864,13.25 10,13.5857864 10,14 C10,14.4142136 10.3357864,14.75 10.75,14.75 Z"
  //       id="Path"
  //       fill="currentColor"
  //       fillRule="nonzero"
  //     ></path>
  //     <path
  //       d="M15.75,14.75 L17.75,14.75 C18.1642136,14.75 18.5,14.4142136 18.5,14 C18.5,13.5857864 18.1642136,13.25 17.75,13.25 L15.75,13.25 C15.3357864,13.25 15,13.5857864 15,14 C15,14.4142136 15.3357864,14.75 15.75,14.75 Z"
  //       id="Path"
  //       fill="currentColor"
  //       fillRule="nonzero"
  //     ></path>
  //     <path
  //       d="M20.75,14.75 L22.75,14.75 C23.1642136,14.75 23.5,14.4142136 23.5,14 C23.5,13.5857864 23.1642136,13.25 22.75,13.25 L20.75,13.25 C20.3357864,13.25 20,13.5857864 20,14 C20,14.4142136 20.3357864,14.75 20.75,14.75 Z"
  //       id="Path"
  //       fill="currentColor"
  //       fillRule="nonzero"
  //     ></path>
  //     <path
  //       d="M6.25,10 L6.25,7 C6.25,6.44771525 6.69771525,6 7.25,6 L12.9765472,6 L12.9765472,6 L21.25,6 C21.8022847,6 22.25,6.44771525 22.25,7 L22.25,10 L22.25,10"
  //       id="Path-7"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //     ></path>
  //     <path
  //       d="M6.25,22.426395 L6.25,19.426395 C6.25,18.8741103 6.69771525,18.426395 7.25,18.426395 L21.25,18.426395 C21.8022847,18.426395 22.25,18.8741103 22.25,19.426395 L22.25,22.426395 L22.25,22.426395"
  //       id="Path-7"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       transform="translate(14.25, 20.4264) scale(1, -1) translate(-14.25, -20.4264)"
  //     ></path>
  //   </g>
  // </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="-50 -50 556.8 459.87"
    {...props}
  >
    <path d="M436.81 166.86c-4.67 11.68-8.1 14-21 14H18.64c-9.86 0-16.2-4.32-18.09-12.28a15.87 15.87 0 0 1 14.1-19.56c2-.17 4-.07 6-.07h395.13c12.92 0 16.36 2.29 21 14Zm0-148.62c-3.27 10.49-10.66 14.06-21.28 13.83-19.11-.42-38.23-.05-57.35-.15-11-.06-18-7.25-17.34-17.37.5-7.57 6.45-14.2 14.07-14.3q33.64-.42 67.32 0c8.11.11 11.8 6.31 14.58 13Zm0 298.24c-3.51 10-10.51 13.67-21.07 13.38-19.76-.56-39.56-.1-59.34-.23a15.62 15.62 0 0 1-15-11.05c-2-6.33 0-13.72 5.63-17.27a21.43 21.43 0 0 1 10.64-3.37c20.61-.32 41.23-.16 61.84-.15 9.38 0 14.41 5.5 17.29 13.7ZM48 .03c10.3 0 20.61-.07 30.91 0 10 .09 16.79 6.59 16.81 15.8s-6.79 16-16.69 16q-31.16.22-62.32 0C7.05 31.75-.14 24.51 0 15.65.15 6.6 7.16.08 17.08 0 27.39-.04 37.69.04 48 .03m-.39 329.67c-10.14 0-20.28.06-30.41 0-9.94-.09-17-6.54-17.19-15.57s7.05-16.23 17.08-16.29q30.91-.18 61.83 0c9.91.06 16.78 6.79 16.8 15.93 0 9.42-6.84 15.84-17.19 15.92s-20.6.01-30.92.01m170.44-.01c-10.14 0-20.28.07-30.42 0s-17.32-6.74-17.26-16c.06-9.07 7-15.83 16.91-15.89q31.17-.21 62.34 0c8.07.05 13.86 4.63 15.94 11.88a14.88 14.88 0 0 1-6.32 17 22.25 22.25 0 0 1-10.31 2.88c-10.26.37-20.57.13-30.88.13M218.44.04c10.31 0 20.61-.09 30.92 0 9.6.1 16.55 6.58 16.78 15.42.23 9.08-6.65 16.3-16.41 16.39q-31.41.32-62.83 0c-9.74-.08-16.69-7.25-16.53-16.29s7-15.42 16.65-15.53c10.47-.08 20.91.01 31.42.01" />
  </svg>
);

export const ToolProbe = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      fill="none"
      fillRule="evenodd"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      transform="translate(4 4)"
    >
      <path d="M10 0L10 3.333M10 16.667L10 20M0 10L3.333 10M16.667 10L20 10" />
      <circle
        cx="10"
        cy="10"
        r="6.667"
      />
      <path d="M10 9.583c.23 0 .417.187.417.417 0 .23-.187.417-.417.417-.23 0-.417-.187-.417-.417 0-.23.187-.417.417-.417" />
    </g>
  </svg>
);

export const ToolDragProbe = (props: IconProps) => (
  <svg
    viewBox="-5 -6 70 70"
    width="28px"
    height="28px"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g strokeWidth="0" />
    <g
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M2.195 36.895c.82-.024 1.407-.657 1.43-1.5.258-10.196 5.508-17.743 13.477-20.696l5.46 15c.047.117.024.211-.093.258-.094.047-.164 0-.235-.07l-2.765-3c-1.805-1.946-4.102-2.086-5.883-.586-2.016 1.71-2.04 4.265-.07 6.68l7.851 9.492c5.93 7.172 12.89 9.398 20.672 6.562 9.305-3.375 13.266-11.906 9.515-22.219l-1.757-4.804c-1.828-5.086-5.32-7.172-9.422-5.742-1.102-1.43-2.79-1.922-4.617-1.266a7.1 7.1 0 0 0-1.828 1.031c-1.196-1.547-3.047-2.11-4.97-1.43a6.5 6.5 0 0 0-1.476.797L24.812 8.09c-1.007-2.79-3.539-3.961-6.14-3.024-2.625.961-3.797 3.47-2.79 6.258l.188.516C7 15.238.695 23.98.695 35.348c0 .843.703 1.57 1.5 1.547m38.836 9.07c-6.14 2.25-11.906 1.101-17.32-5.438l-7.852-9.445c-.843-.984-.843-1.945-.093-2.602.703-.632 1.664-.421 2.437.375l5.414 5.602c.914.938 1.711 1.031 2.485.75.914-.328 1.312-1.312.937-2.32l-8.297-22.828c-.351-.938.07-1.828.961-2.157.914-.328 1.758.118 2.11 1.055l5.93 16.29c.28.773 1.148 1.124 1.921.843.75-.281 1.148-1.102.867-1.852l-2.133-5.882c.329-.305.774-.61 1.22-.774 1.1-.398 2.015.094 2.437 1.242l1.875 5.133c.28.797 1.148 1.102 1.898.82.727-.258 1.195-1.03.89-1.851l-1.523-4.149a3.55 3.55 0 0 1 1.219-.797c1.102-.398 2.016.094 2.438 1.243l1.242 3.422c.304.82 1.172 1.125 1.922.843a1.446 1.446 0 0 0 .89-1.851l-.937-2.532c1.968-.703 3.82.891 5.085 4.407l1.477 4.008c3.211 8.859.281 15.609-7.5 18.445" />
  </svg>
);

export const ToolReset = (props: IconProps) => (
  <svg
    width="32px"
    height="32px"
    viewBox="0 -2 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      transform="translate(2 1)"
      fill="currentColor"
      fillRule="evenodd"
    >
      <path d="M6.6 8.1v-8l-4 4z" />
      <path d="M-.165 11.5H8a3 3 0 1 0 0-6.9H6.417L6.38 3H8a5 5 0 0 1 0 10H-.126z" />
      <circle
        cx=".437"
        cy="4.15"
        r="1.75"
        fill="#db5860"
      />
    </g>
  </svg>
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <g
  //     id="tool-reset"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     ></rect>
  //     <polyline
  //       id="Path"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //       points="15.7879373 10.9230769 22.7110142 10.9230769 22.7110142 4"
  //     ></polyline>
  //     <path
  //       d="M22.1848604,10.9230769 C20.7833124,6.95640473 16.8769835,4.43920288 12.6856477,4.80187309 C8.49431195,5.16454329 5.07842549,8.3153258 4.37906817,12.4637863 C3.67971085,16.6122468 5.8738281,20.708777 9.71461129,22.4255209 C13.5553945,24.1422648 18.0710813,23.0448664 20.6956296,19.7569231"
  //       id="Path"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     ></path>
  //   </g>
  // </svg>
);

export const ToolRotateRight = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-70 -80 712 712"
    fill="currentColor"
    {...props}
  >
    <path d="M105.986 436.15a233.5 233.5 0 0 1-27.877-26.519c-3.697-4.148-10.048-4.511-14.186-.821-4.146 3.69-4.511 10.042-.822 14.185a253.7 253.7 0 0 0 30.285 28.81 10 10 0 0 0 6.292 2.22c2.939 0 5.851-1.282 7.835-3.748 3.48-4.323 2.795-10.647-1.527-14.127m66.876 37.501a230.6 230.6 0 0 1-35.008-15.952c-4.842-2.714-10.963-.989-13.678 3.848-2.716 4.84-.993 10.964 3.846 13.68a251 251 0 0 0 38.064 17.346c1.121.4 2.264.59 3.388.59 4.124 0 7.99-2.559 9.459-6.664 1.872-5.226-.849-10.977-6.071-12.848M54.994 378.887a231 231 0 0 1-17.687-34.13c-2.132-5.12-8.017-7.546-13.136-5.414-5.124 2.133-7.548 8.015-5.414 13.139a251 251 0 0 0 19.227 37.105 10.04 10.04 0 0 0 8.514 4.699 10 10 0 0 0 5.34-1.544c4.699-2.955 6.112-9.157 3.156-13.855m-33.855-197.45c-5.348-1.489-10.889 1.636-12.378 6.98a251 251 0 0 0-7.818 41.088c-.579 5.518 3.427 10.462 8.944 11.041q.536.057 1.062.057c5.078 0 9.439-3.838 9.981-9a230.7 230.7 0 0 1 7.19-37.788c1.49-5.346-1.636-10.888-6.981-12.378m4.423 126.712a232 232 0 0 1-5.483-38.064c-.334-5.539-5.068-9.744-10.634-9.426-5.539.334-9.761 5.094-9.427 10.633a252 252 0 0 0 5.963 41.371c1.07 4.649 5.206 7.793 9.781 7.793.748 0 1.509-.085 2.266-.259 5.407-1.247 8.78-6.64 7.534-12.048m432.24 71.962c-4.636-3.055-10.865-1.769-13.919 2.864a232.7 232.7 0 0 1-23.758 30.264c-3.778 4.066-3.542 10.423.525 14.199a10 10 0 0 0 6.834 2.686c2.696 0 5.385-1.078 7.364-3.21a253 253 0 0 0 25.818-32.886c3.053-4.633 1.77-10.864-2.864-13.917M248.318 487.092a233 233 0 0 1-38.3-3.564 10.033 10.033 0 0 0-11.652 8.136c-.971 5.463 2.671 10.68 8.134 11.651a253.5 253.5 0 0 0 41.611 3.873h.105c5.5 0 9.989-4.43 10.045-9.943.058-5.55-4.394-10.096-9.943-10.153m157.469-46.099c-3.39-4.396-9.695-5.214-14.09-1.825a232 232 0 0 1-32.314 20.871c-4.894 2.612-6.746 8.7-4.133 13.595a10.05 10.05 0 0 0 8.875 5.32c1.595 0 3.214-.382 4.722-1.186a252.4 252.4 0 0 0 35.116-22.681c4.395-3.388 5.212-9.698 1.824-14.094m-69.007 40.589c-1.759-5.263-7.465-8.099-12.714-6.344a230 230 0 0 1-37.368 9.089c-5.483.856-9.233 5.994-8.377 11.478.775 4.958 5.048 8.499 9.915 8.499q.774.001 1.563-.121a250.4 250.4 0 0 0 40.635-9.886c5.265-1.759 8.105-7.452 6.346-12.715M504.55 96.294c-5.36-1.434-10.869 1.744-12.305 7.105L479.3 151.707C438.824 62.934 349.882 4.813 250.756 4.813c-93.109 0-178.139 51.107-221.904 133.379-2.608 4.899-.748 10.982 4.151 13.589 4.906 2.609 10.987.747 13.59-4.152 40.269-75.697 118.5-122.721 204.164-122.721 94.442 0 178.838 57.338 214.066 143.957l-58.718-15.734c-5.36-1.44-10.869 1.744-12.305 7.105-1.438 5.36 1.744 10.869 7.104 12.306l77.642 20.804c.871.233 1.747.345 2.608.345 4.435 0 8.495-2.961 9.697-7.45l20.804-77.642c1.437-5.36-1.745-10.869-7.105-12.305" />
  </svg>
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <g
  //     id="tool-rotate-right"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     ></rect>
  //     <rect
  //       id="Rectangle"
  //       fill="currentColor"
  //       x="9.55555556"
  //       y="13"
  //       width="14.4444444"
  //       height="11.1111111"
  //       rx="2"
  //     ></rect>
  //     <g
  //       id="Group-11"
  //       transform="translate(4, 3)"
  //       stroke="currentColor"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //       strokeWidth="1.5"
  //     >
  //       <path
  //         d="M8.88888889,3.33333333 L4.44444444,3.33333333 C1.98984556,3.33333333 0,5.32317889 0,7.77777778 L0,12.2222222"
  //         id="Path"
  //       ></path>
  //       <polyline
  //         id="Path"
  //         points="5.55555556 0 8.88888889 3.33333333 5.55555556 6.66666667"
  //       ></polyline>
  //     </g>
  //   </g>
  // </svg>
);

export const ToolSegBrush = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-seg-brush"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="24"
        height="24"
      ></rect>
      <path
        d="M3.24640621,21.8286833 C3.09173375,21.7551472 2.99513748,21.5971513 3.00018895,21.4259625 C3.00524042,21.2547737 3.11098486,21.1027485 3.26972426,21.0384606 C5.3260304,20.2059201 4.66362518,17.8620247 5.27421252,16.6088957 C6.02197747,15.1026514 7.84114758,14.4766383 9.35746132,15.2037675 C13.9485253,17.4422999 8.48346644,24.3211232 3.24640621,21.8286833 Z"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M21.5968442,2.302022 C21.1256527,1.8826075 20.4094461,1.90228142 19.9619901,2.34693083 L9.69255027,12.5887345 C11.0536437,13.0051578 12.1843437,13.9616637 12.8206229,15.2349008 L21.7410706,3.93687606 C22.1347378,3.44008272 22.0714081,2.72222021 21.5968442,2.302022 Z"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </g>
  </svg>
);

export const ToolSegEraser = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-seg-eraser"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="24"
        height="24"
      ></rect>
      <path
        d="M8.47826087,18.0030772 C7.48731947,17.9495317 6.54439458,17.5591084 5.80565217,16.8964685 L4.1066087,15.1958598 C3.49763625,14.5834856 3.49763625,13.5942339 4.1066087,12.9818598 L13.6317391,3.45672934 C14.2441133,2.84775689 15.233365,2.84775689 15.8457391,3.45672934 L19.8926087,7.5035989 C20.5015811,8.11597307 20.5015811,9.10522473 19.8926087,9.7175989 L12.7153043,16.8949033 C11.9769855,17.5579476 11.0343414,17.9489213 10.0434783,18.0030772 L8.47826087,18.0030772 Z"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <line
        x1="10.0434783"
        y1="7.04499021"
        x2="16.3043478"
        y2="13.3058598"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
      <line
        x1="3"
        y1="20.5667293"
        x2="21"
        y2="20.5667293"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
    </g>
  </svg>
);

export const ToolSegShape = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-seg-shape"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="24"
        height="24"
      ></rect>
      <circle
        id="Oval"
        stroke="currentColor"
        strokeWidth="1.5"
        cx="16"
        cy="15"
        r="6"
      ></circle>
      <rect
        id="Rectangle"
        stroke="currentColor"
        strokeWidth="1.5"
        x="3"
        y="3"
        width="13"
        height="13"
        rx="2"
      ></rect>
    </g>
  </svg>
);

export const ToolSegThreshold = (props: IconProps) => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-seg-threshold"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="24"
        height="24"
      ></rect>
      <g
        id="Group"
        transform="translate(2.4184, 14.3673)"
        stroke="currentColor"
        strokeWidth="1.5"
      >
        <line
          x1="16.5816327"
          y1="2.13265306"
          x2="19.0816327"
          y2="2.13265306"
          id="Line-2"
          strokeLinecap="round"
        ></line>
        <line
          x1="0.0816326531"
          y1="2.13265306"
          x2="12.0816327"
          y2="2.13265306"
          id="Line-2"
          strokeLinecap="round"
        ></line>
        <circle
          id="Oval"
          cx="14.2244898"
          cy="2.09183673"
          r="2.09183673"
        ></circle>
      </g>
      <g
        id="Group"
        transform="translate(11.7092, 7.4592) scale(-1, 1) translate(-11.7092, -7.4592)translate(1.9184, 5.3673)"
        stroke="currentColor"
        strokeWidth="1.5"
      >
        <line
          x1="16"
          y1="2.13265306"
          x2="19.0816327"
          y2="2.13265306"
          id="Line-2"
          strokeLinecap="round"
        ></line>
        <line
          x1="0.0816326531"
          y1="2.13265306"
          x2="11"
          y2="2.13265306"
          id="Line-2"
          strokeLinecap="round"
        ></line>
        <circle
          id="Oval"
          cx="13.2244898"
          cy="2.09183673"
          r="2.09183673"
        ></circle>
      </g>
    </g>
  </svg>
);

export const ToolSplineRoi = (props: IconProps) => (
  <svg
    height="200"
    width="200"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="-70 -70 652 652"
    {...props}
  >
    <g strokeWidth="0" />
    <g
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M503.467 0h-51.2a8.536 8.536 0 0 0-8.533 8.533v18.338c-94.61 14.968-181.044 55.698-250.625 118.196h-48.043a8.536 8.536 0 0 0-8.533 8.533v48.606C78.848 270.131 41.054 353.425 26.854 443.733H8.533A8.536 8.536 0 0 0 0 452.266v51.2C0 508.177 3.823 512 8.533 512h51.2a8.536 8.536 0 0 0 8.533-8.533v-51.2a8.536 8.536 0 0 0-8.533-8.533h-15.59c14.02-86.144 50.278-165.547 105.327-230.4h46.797a8.536 8.536 0 0 0 8.533-8.533v-47.283C271.215 97.954 353.562 58.931 443.733 44.16v15.573a8.536 8.536 0 0 0 8.533 8.533h51.2a8.536 8.536 0 0 0 8.533-8.533v-51.2C512 3.823 508.177 0 503.467 0M51.2 460.8v34.133H17.067V460.8zm136.533-264.533H153.6v-34.133h34.133zM494.933 51.2H460.8V17.067h34.133z" />
  </svg>
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <g
  //     id="tool-spline-roi"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     ></rect>
  //     <g
  //       id="Group-3"
  //       transform="translate(5, 5)"
  //       stroke="currentColor"
  //       strokeLinejoin="round"
  //       strokeWidth="1.5"
  //     >
  //       <path
  //         d="M5,4 C6.80276265,2.42407491 9.10583462,1.538278 11.5,1.5 L15.5,1.5"
  //         id="Path"
  //       ></path>
  //       <path
  //         d="M1.5,15.5 L1.5,11.5 C1.50313857,9.33936854 2.19845937,7.23658385 3.484,5.5"
  //         id="Path"
  //       ></path>
  //       <circle
  //         id="Oval"
  //         strokeLinecap="round"
  //         cx="4"
  //         cy="4.5"
  //         r="1.5"
  //       ></circle>
  //       <circle
  //         id="Oval"
  //         strokeLinecap="round"
  //         cx="17.5"
  //         cy="1.5"
  //         r="1.5"
  //       ></circle>
  //       <circle
  //         id="Oval"
  //         strokeLinecap="round"
  //         cx="1.5"
  //         cy="17.5"
  //         r="1.5"
  //       ></circle>
  //     </g>
  //   </g>
  // </svg>
);

export const ToolStackImageSync = (props: IconProps) => (
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <g
  //     id="tool-stack-image-sync"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     ></rect>
  //     <path
  //       d="M16.4346891,14.4875228 L16.5216447,14.5744783 C17.2833202,15.336115 18.5181991,15.336115 19.2798746,14.5744783 L23.1459183,10.7049564 C24.2824086,9.55997894 24.2824086,7.71258895 23.1459183,6.56761146 L21.4311549,4.85371762 C20.2872588,3.71542746 18.4385755,3.71542746 17.2946795,4.85371762 L13.4277663,8.71976127 C12.6661296,9.48143685 12.6661296,10.7163157 13.4277663,11.4779913 L13.5147218,11.5649468"
  //       id="Path"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     ></path>
  //     <path
  //       d="M11.5651784,13.5118815 L11.4782229,13.424926 C10.7165473,12.6632893 9.48166848,12.6632893 8.7199929,13.424926 L4.85307969,17.2944478 C3.7156401,18.439034 3.7156401,20.2872066 4.85307969,21.4317928 L6.56697354,23.1456867 C7.71077373,24.2850306 9.56051831,24.2850306 10.7043185,23.1456867 L14.5703622,19.279643 C14.9365407,18.9140991 15.1423111,18.4179341 15.1423111,17.900528 C15.1423111,17.3831219 14.9365407,16.8869569 14.5703622,16.521413 L14.4834066,16.4344575"
  //       id="Path"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     ></path>
  //     <line
  //       x1="10.2069328"
  //       y1="17.7927031"
  //       x2="17.7911957"
  //       y2="10.2067011"
  //       id="Path"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     ></line>
  //   </g>
  // </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 441.75 441.75"
    fill="currentColor"
    {...props}
  >
    <path
      d="M162.78 314.53c-6.11-1.83-11.92-3.6-17.75-5.29-2.62-.76-4.53-2.26-5.15-5a7 7 0 0 1 2.21-7.17q24.09-22.51 48.09-45.13t47.92-45q24.67-23.19 49.33-46.4c6.83-6.42 13.7-12.8 20.52-19.23a7.13 7.13 0 0 1 6.92-1.93q17.91 4.19 35.71 8.39a6.61 6.61 0 0 1 5.32 6.14 26 26 0 0 1 .11 2.77v114.8a10.77 10.77 0 0 1-4 8.77q-36.57 32.32-73 64.85a7.36 7.36 0 0 1-7.49 1.82c-3.92-1.18-7.86-2.29-11.77-3.52a2.51 2.51 0 0 0-2.94.71c-22.07 22.14-44.21 44.19-66.23 66.38a11.76 11.76 0 0 1-9.09 3.74c-33.77-.1-67.54-.06-101.31-.06-5.38 0-8.71-3.85-7.39-8.69a7.55 7.55 0 0 1 1.88-3.17q19.74-19.79 39.55-39.48 12-12 24.06-23.87l23.48-23.33c.36-.27.59-.58 1.02-1.1m-2.73-15.33c.72.26 1.19.46 1.67.61l27.52 8.19q40.62 12.11 81.23 24.24a2.77 2.77 0 0 0 3-.62q33.54-29.89 67.16-59.73a4.33 4.33 0 0 0 1.61-3.56c-.06-19.42 0-38.85 0-58.27v-48.17c0-1.42-.34-2-1.85-2.38-7.8-1.73-15.57-3.58-23.33-5.48a3.11 3.11 0 0 0-3.49.91c-1.85 2-3.9 3.75-5.88 5.6q-16.65 15.65-33.34 31.33t-33.31 31.34q-19.26 18.06-38.56 36.12l-33.94 31.84c-2.76 2.61-5.53 5.24-8.47 8.03ZM96.5 399.73l.42.54a3 3 0 0 0 .56.1h82.47a3.8 3.8 0 0 0 2.36-1.08q29.69-29.61 59.31-59.28c.43-.42.81-.9 1.26-1.42a5 5 0 0 0-.77-.39q-31.41-9.37-62.85-18.67a2.9 2.9 0 0 0-2.32.75q-18.72 18.4-37.34 36.93-16.67 16.55-33.31 33.1c-3.22 3.16-6.51 6.27-9.79 9.42m171.16 14.44h-28.52c-4.5 0-7.58-2.73-7.65-6.78s3-7 7.65-7h57.44c3.79 0 6.53 2.14 7.21 5.51a6.67 6.67 0 0 1-4 7.62 9.8 9.8 0 0 1-3.65.63c-9.46.05-18.97.02-28.48.02m82.12 0h-5.94c-4-.06-6.91-2.77-7-6.56a6.64 6.64 0 0 1 6.75-7.19q6.15-.16 12.28 0a6.882 6.882 0 1 1-.34 13.76Z"
      data-name="2gRQv5"
    />
  </svg>
);

export const ToolStackScroll = (props: IconProps) => (
  <svg
    width="28"
    height="28"
    fill="none"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m1.308 5.12 6.49 3.539a.5.5 0 0 0 .314.027q.056-.014.096-.027l6.573-3.54a.39.39 0 0 0 .218-.395.43.43 0 0 0-.061-.226.4.4 0 0 0-.171-.157l-6.49-3.293a.43.43 0 0 0-.397 0L1.321 4.34a.46.46 0 0 0-.177.157.4.4 0 0 0-.069.226q0 .273.233.396M8.07 1.922l5.548 2.829-5.616 3.02-5.548-3.02zm6.614 5.63-1.298-.656-.93.506 1.094.56-5.616 3.02-5.548-3.02 1.162-.588-.93-.505-1.38.683a.42.42 0 0 0-.239.39.4.4 0 0 0 .226.389l6.49 3.539a.5.5 0 0 0 .219.055.4.4 0 0 0 .102-.014.6.6 0 0 0 .103-.041l6.558-3.54a.41.41 0 0 0 .233-.389.41.41 0 0 0-.246-.389m0 3.06-1.23-.6-.929.505 1.025.506-5.616 3.02-5.548-3.02 1.08-.492-.93-.506-1.298.588a.42.42 0 0 0-.239.39.4.4 0 0 0 .226.389l6.49 3.539q.042.013.075.027a.39.39 0 0 0 .349-.027l6.559-3.54a.41.41 0 0 0 .232-.389.41.41 0 0 0-.246-.39"
      fill="currentColor"
    />
  </svg>
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <g
  //     id="tool-stack-scroll"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     ></rect>
  //     <rect
  //       id="Rectangle"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       x="4"
  //       y="9.71428571"
  //       width="14.2857143"
  //       height="14.2857143"
  //       rx="2"
  //     ></rect>
  //     <path
  //       d="M7.0094401,6.85714286 L18.9906762,6.85714286 C20.0952457,6.85714286 20.9906762,7.75257336 20.9906762,8.85714286 L20.9906762,21.1428571 L20.9906762,21.1428571"
  //       id="Path-3"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //     ></path>
  //     <path
  //       d="M9.71428571,4 L21.6955218,4 C22.8000913,4 23.6955218,4.8954305 23.6955218,6 L23.6955218,18.2857143 L23.6955218,18.2857143"
  //       id="Path-3"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //     ></path>
  //   </g>
  // </svg>
);

export const ToolToggleDicomOverlay = (props: IconProps) => (
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <g
  //     id="tool-toggle-dicom-overlay"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     ></rect>
  //     <path
  //       d="M21.5629346,19 C21.9081126,19 22.1879346,19.279822 22.1879346,19.625 C22.1879346,19.970178 21.9081126,20.25 21.5629346,20.25 L20.2129346,20.25 C19.8677566,20.25 19.5879346,19.970178 19.5879346,19.625 C19.5879346,19.279822 19.8677566,19 20.2129346,19 L21.5629346,19 Z M17.4829346,19 C17.8281125,19 18.1079346,19.279822 18.1079346,19.625 C18.1079346,19.970178 17.8281125,20.25 17.4829346,20.25 L16.1329346,20.25 C15.7877566,20.25 15.5079346,19.970178 15.5079346,19.625 C15.5079346,19.279822 15.7877566,19 16.1329346,19 L17.4829346,19 Z M13.4029345,19 C13.7481125,19 14.0279345,19.279822 14.0279345,19.625 C14.0279345,19.970178 13.7481125,20.25 13.4029345,20.25 L12.0529345,20.25 C11.7077565,20.25 11.4279345,19.970178 11.4279345,19.625 C11.4279345,19.279822 11.7077565,19 12.0529345,19 L13.4029345,19 Z M8.98988002,17.034041 C9.33501017,17.0282959 9.61945075,17.3034219 9.62519584,17.648552 C9.63057519,17.9717108 9.74731641,18.2750986 9.95299373,18.5163531 C10.1769336,18.7790292 10.1455318,19.1735095 9.88285564,19.3974494 C9.62017952,19.6213893 9.22569928,19.5899874 9.00175936,19.3273113 C8.60957687,18.8672907 8.38562164,18.2852745 8.37536899,17.6693568 C8.3696239,17.3242267 8.64474986,17.0397861 8.98988002,17.034041 Z M24,16.4185328 C24.345178,16.4185328 24.625,16.6983548 24.625,17.0435328 L24.625,17.625 C24.625,17.9681799 24.5587904,18.303203 24.431654,18.6151793 C24.3013887,18.9348335 23.936657,19.0883635 23.6170028,18.9580982 C23.2973486,18.8278329 23.1438186,18.4631012 23.2740839,18.143447 C23.3404391,17.9806197 23.375,17.8057405 23.375,17.625 L23.375,17.0435328 C23.375,16.6983548 23.654822,16.4185328 24,16.4185328 Z M9,12.9544019 C9.34517797,12.9544019 9.625,13.2342239 9.625,13.5794019 L9.625,14.9294019 C9.625,15.2745799 9.34517797,15.5544019 9,15.5544019 C8.65482203,15.5544019 8.375,15.2745799 8.375,14.9294019 L8.375,13.5794019 C8.375,13.2342239 8.65482203,12.9544019 9,12.9544019 Z M24,12.3385328 C24.345178,12.3385328 24.625,12.6183548 24.625,12.9635328 L24.625,14.3135328 C24.625,14.6587107 24.345178,14.9385328 24,14.9385328 C23.654822,14.9385328 23.375,14.6587107 23.375,14.3135328 L23.375,12.9635328 C23.375,12.6183548 23.654822,12.3385328 24,12.3385328 Z M9,8.87440184 C9.34517797,8.87440184 9.625,9.15422387 9.625,9.49940184 L9.625,10.8494019 C9.625,11.1945798 9.34517797,11.4744019 9,11.4744019 C8.65482203,11.4744019 8.375,11.1945798 8.375,10.8494019 L8.375,9.49940184 C8.375,9.15422387 8.65482203,8.87440184 9,8.87440184 Z M24,8.25853271 C24.345178,8.25853271 24.625,8.53835474 24.625,8.88353271 L24.625,10.2335327 C24.625,10.5787107 24.345178,10.8585327 24,10.8585327 C23.654822,10.8585327 23.375,10.5787107 23.375,10.2335327 L23.375,8.88353271 C23.375,8.53835474 23.654822,8.25853271 24,8.25853271 Z M8.85203131,5.11578232 C9.05066164,4.83348137 9.44053346,4.76565293 9.72283441,4.96428326 C10.0051354,5.16291358 10.0729638,5.55278541 9.87433347,5.83508635 C9.71277357,6.06470142 9.625,6.33744835 9.625,6.625 L9.625,6.76940182 C9.625,7.11457979 9.34517797,7.39440182 9,7.39440182 C8.65482203,7.39440182 8.375,7.11457979 8.375,6.76940182 L8.375,6.625 C8.375,6.07783578 8.54347711,5.55431124 8.85203131,5.11578232 Z M22.6742845,4.64042222 C22.8779596,4.36173907 23.2689882,4.30093301 23.5476713,4.50460808 C24.037257,4.86242093 24.3909544,5.3800285 24.5426114,5.97056314 C24.6284714,6.30489214 24.4270475,6.64552267 24.0927185,6.73138272 C23.7583895,6.81724277 23.417759,6.61581889 23.331899,6.28148989 C23.2527262,5.9732005 23.0672181,5.70172435 22.8100986,5.51380903 C22.5314155,5.31013396 22.4706094,4.91910536 22.6742845,4.64042222 Z M12.35,4 C12.695178,4 12.975,4.27982203 12.975,4.625 C12.975,4.97017797 12.695178,5.25 12.35,5.25 L11,5.25 C10.654822,5.25 10.375,4.97017797 10.375,4.625 C10.375,4.27982203 10.654822,4 11,4 L12.35,4 Z M16.4300001,4 C16.775178,4 17.0550001,4.27982203 17.0550001,4.625 C17.0550001,4.97017797 16.775178,5.25 16.4300001,5.25 L15.08,5.25 C14.7348221,5.25 14.455,4.97017797 14.455,4.625 C14.455,4.27982203 14.7348221,4 15.08,4 L16.4300001,4 Z M20.5100001,4 C20.8551781,4 21.1350001,4.27982203 21.1350001,4.625 C21.1350001,4.97017797 20.8551781,5.25 20.5100001,5.25 L19.1600001,5.25 C18.8148221,5.25 18.5350001,4.97017797 18.5350001,4.625 C18.5350001,4.27982203 18.8148221,4 19.1600001,4 L20.5100001,4 Z"
  //       id="Rectangle"
  //       fill="currentColor"
  //       fillRule="nonzero"
  //       transform="translate(16.5, 12.125) rotate(180) translate(-16.5, -12.125)"
  //     ></path>
  //     <path
  //       d="M6.1678365,9.125 L5.5,9.125 C4.3954305,9.125 3.5,10.0204305 3.5,11.125 L3.5,22.125 C3.5,23.2295695 4.3954305,24.125 5.5,24.125 L16.5,24.125 C17.6045695,24.125 18.5,23.2295695 18.5,22.125 L18.5,21.9543874 L18.5,21.9543874"
  //       id="Path-9"
  //       stroke="currentColor"
  //       strokeWidth="1.25"
  //       strokeLinecap="round"
  //     ></path>
  //   </g>
  // </svg>
  <svg
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-70 -70 709.55 711.01"
    {...props}
  >
    <path d="M502.24-.03c5.47 2.55 7.53 6.81 7.29 12.82-.33 8.11 0 16.25-.11 24.38-.08 6.71-3.79 10.8-9.64 10.92-6 .13-10-4.07-10.27-10.93-.1-2.81 0-5.64 0-8.46v-8.79c-6.08 0-12 .06-17.85 0-4.14-.06-7.94-1.77-9.07-5.69-.86-3-.31-6.72.7-9.77.61-1.84 3.29-3 5-4.46Zm-327.36 0c2.1 2.23 4.93 4.11 6.14 6.75 2.82 6.14-1.95 12.73-9.09 13.16-3 .18-6 .05-9 .05h-9.4c0 6.09.12 11.68 0 17.27-.17 6.07-3.34 10-8.3 10.77-6.37 1-11.37-3.12-11.52-9.87-.22-9.29 0-18.58-.08-27.87 0-5.24 3.07-8.12 7.31-10.26Zm81.84 0c2.3 2.84 5.68 5.34 6.66 8.58 1.75 5.79-3.34 11.19-9.93 11.33-8.28.17-16.57.06-24.86.05-7.31 0-11.34-2.3-12.67-7.19-1.42-5.21.63-9 6.87-12.77Zm81.84 0c4 2.37 7.3 5.17 7 10.43s-4.28 9.37-10.16 9.48c-9.11.16-18.23.05-27.34 0-5.06 0-8.61-2.35-10.21-7.14-1.53-4.57.5-8.89 5.12-11.75.55-.34 1.08-.71 1.63-1.06Zm81.84 0c1.87 1.56 4.22 2.81 5.54 4.75a9.7 9.7 0 0 1-8 15.1c-9.6.33-19.22.2-28.83 0-4.85-.09-8.17-2.85-9.36-7.5-1.13-4.43.44-8.15 4.29-10.78.81-.55 1.64-1.07 2.46-1.6Zm-400.23 152v339.07h121a36 36 0 0 1 5 .13 9.92 9.92 0 0 1 .16 19.66 29 29 0 0 1-4.48.16H13.13c-10 0-13.12-3.12-13.12-13.1V145.22c0-9.95 3.22-13.22 13.08-13.23h84.8a22.9 22.9 0 0 1 6.4.76 9.78 9.78 0 0 1-1.8 19 43 43 0 0 1-5.47.18H20.17ZM357.8 491.04v-77.21c0-1.5-.07-3 .06-4.49.51-6.12 4.68-10.22 10.21-10.1s9.57 4.23 9.63 10.53c.13 13.63.06 27.26.06 40.9v47.88c0 9-3.41 12.44-12.29 12.45h-130.2a26.4 26.4 0 0 1-4-.14 9.94 9.94 0 0 1 0-19.67 34.4 34.4 0 0 1 5-.14H357.8Zm131.69-131.43c0-6-.07-11.29 0-16.56.12-7.16 4.14-11.73 10.13-11.68s9.76 4.45 9.8 11.86c0 8.46.09 16.92 0 25.39-.09 7.15-3.64 10.76-10.71 10.85q-13.44.18-26.88 0c-6.27-.08-10.36-4-10.5-9.59s3.86-9.88 10-10.2c5.78-.31 11.58-.07 18.16-.07" />
    <path d="M153.35 359.55c5.61 0 10.39-.08 15.17 0a24.4 24.4 0 0 1 6.4.79 9.69 9.69 0 0 1 6.8 10.38c-.57 4.68-4.11 8.48-8.92 8.59q-15.19.36-30.43 0a8.69 8.69 0 0 1-8.57-8.76q-.41-15 0-29.92a9.77 9.77 0 0 1 19.48-.37c.45 6.12.07 12.29.07 19.29M357.8 151.97c-6.08 0-11.37.07-16.66 0-6.65-.11-10.92-3.88-11.09-9.6-.17-5.92 4.19-10.16 11-10.29 8.65-.16 17.3-.18 25.94 0 7 .16 10.63 4 10.72 11q.18 13 0 25.93c-.09 6.67-4 10.76-9.83 10.78s-9.74-4.1-10-10.69c-.13-2.82 0-5.65 0-8.48ZM133.67 269.59c0-4.65-.16-9.3.05-13.94.26-5.78 4.44-9.87 9.76-9.9a9.61 9.61 0 0 1 9.85 9.29c.36 9.94.36 19.91 0 29.85a9.49 9.49 0 0 1-9.94 9.13c-5.37-.11-9.41-4.14-9.65-10-.23-4.8-.07-9.62-.07-14.43m.01-81.94c0-4.65-.16-9.3 0-13.94.26-5.78 4.45-9.85 9.77-9.88a9.61 9.61 0 0 1 9.85 9.29c.36 9.94.37 19.91 0 29.84-.22 5.6-4.7 9.18-10 9.08-5.44-.1-9.4-4-9.64-10-.14-4.76.01-9.58.02-14.39m375.74-77.84c0 4.65.13 9.3 0 13.94-.21 5.93-4.1 9.87-9.57 10a9.65 9.65 0 0 1-10.15-9.48c-.34-9.61-.34-19.25 0-28.86a9.6 9.6 0 0 1 10.4-9.71c5.45.22 9.19 4.17 9.38 10.16.06 4.66-.06 9.31-.06 13.95m-.02 163.58c0 4.81.15 9.63 0 14.43-.22 5.66-4 9.48-9.29 9.72s-10-3.16-10.27-8.68c-.44-10.26-.44-20.57 0-30.83.26-5.43 5.19-8.87 10.42-8.52 5.06.34 8.68 4.09 9.12 9.44 0 .33.05.67.05 1v13.44Zm-269.87 106.1c-4.65 0-9.3.12-13.94 0-5.73-.19-9.6-3.84-9.93-9.08-.35-5.58 3.09-10.28 8.91-10.53 10.09-.42 20.23-.41 30.33 0 5.52.25 9 5 8.79 10.2s-4.12 9-9.73 9.37h-1Zm269.88-187.68c0 4.65.14 9.3 0 13.94-.21 5.71-3.9 9.56-9.15 9.88-5.47.33-10.26-3.29-10.5-9-.41-9.93-.4-19.9 0-29.84.22-5.75 4.93-9.41 10.4-9.14 5.26.26 8.92 4.1 9.29 9.76v14.44ZM321.35 379.49c-4.64 0-9.29.12-13.93 0-5.69-.2-9.56-3.9-9.87-9.14-.33-5.52 3.2-10.22 9-10.47 9.94-.43 19.91-.43 29.84 0 5.8.23 9.45 4.94 9.17 10.37s-4.21 9.05-10.21 9.22c-4.69.13-9.34.02-14 .02m82.07-.03c-4.81 0-9.62.16-14.43 0a9.52 9.52 0 0 1-9.53-9c-.4-5.29 2.93-10.21 8.39-10.47 10.42-.49 20.89-.49 31.3 0 5.47.27 8.73 5.19 8.3 10.53-.41 5-4.19 8.68-9.59 8.9-4.81.2-9.63.05-14.44.04M133.69 106.04c0-4.81-.17-9.62.05-14.42a9.74 9.74 0 0 1 9.43-9.68 9.47 9.47 0 0 1 10.1 8.94c.41 10.09.42 20.23 0 30.32-.23 5.61-4.73 9-10.09 8.85s-9.18-3.92-9.44-9.58c-.23-4.8-.05-9.62-.05-14.43m64.46 45.87c-4.82 0-9.64.15-14.45 0-5.66-.22-9.54-4-9.82-9.27a9.56 9.56 0 0 1 9.22-10.39c9.78-.38 19.61-.37 29.39 0a9.67 9.67 0 0 1 9.16 10c-.12 5.38-4.2 9.31-10 9.67h-13.5Zm179.55 81.96c0 4.65.17 9.31-.05 14-.26 5.62-4.19 9.46-9.44 9.65s-9.89-3.45-10.12-8.95c-.41-9.95-.41-19.94 0-29.89a9.55 9.55 0 0 1 10.15-8.93c5.23.23 9.16 4.12 9.41 9.72.22 4.76.05 9.58.05 14.4m-.01 81.68c0 4.65.18 9.31 0 13.95a9.82 9.82 0 0 1-9.53 9.63c-4.88.15-9.72-3.42-9.94-8.61-.43-10.27-.44-20.58 0-30.85.25-5.25 5-8.5 10.1-8.28s8.83 3.91 9.34 9.21c0 .33.06.66.06 1v14ZM277.18 151.97c-4.65 0-9.31.14-14-.05-5.66-.23-9.47-4.06-9.68-9.34s3.15-10 8.73-10.22c9.94-.45 19.92-.44 29.86 0a9.49 9.49 0 0 1 9.05 10c-.15 5.38-4.22 9.37-10.07 9.58-4.59.11-9.24.03-13.89.03M198.8 501.06a9.94 9.94 0 0 1-19.88.22 10.33 10.33 0 0 1 10.15-10.18 10 10 0 0 1 9.73 9.96" />
  </svg>
);

export const ToolUltrasoundBidirectional = (props: IconProps) => (
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <g
  //     id="tool-ultrasound-bidirectional"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <line
  //       x1="4"
  //       y1="17.5"
  //       x2="4"
  //       y2="23.5"
  //       id="Line"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="square"
  //     ></line>
  //     <line
  //       x1="7.5"
  //       y1="20.5"
  //       x2="7.5"
  //       y2="26.5"
  //       id="Line"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="square"
  //       transform="translate(7.5, 23.5) rotate(-90) translate(-7.5, -23.5)"
  //     ></line>
  //     <circle
  //       id="Oval"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //       cx="4"
  //       cy="15.5"
  //       r="1.5"
  //     ></circle>
  //     <circle
  //       id="Oval"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //       cx="12.5"
  //       cy="23.5"
  //       r="1.5"
  //     ></circle>
  //     <rect
  //       id="Rectangle"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       x="8"
  //       y="4"
  //       width="17"
  //       height="10"
  //       rx="2"
  //     ></rect>
  //     <g
  //       id="US"
  //       transform="translate(11.6055, 6.5586)"
  //       fill="currentColor"
  //       fillRule="nonzero"
  //     >
  //       <path
  //         d="M2.15625,4.61328125 C1.49609375,4.61328125 1.05859375,4.21875 1.05859375,3.4921875 L1.05859375,0.109375 L0,0.109375 L0,3.6015625 C0,4.76953125 0.84375,5.54296875 2.15625,5.54296875 C3.46484375,5.54296875 4.30859375,4.76953125 4.30859375,3.6015625 L4.30859375,0.109375 L3.25,0.109375 L3.25,3.4921875 C3.25,4.21484375 2.8125,4.61328125 2.15625,4.61328125 Z"
  //         id="Path"
  //       ></path>
  //       <path
  //         d="M5.25390625,3.97265625 C5.30078125,4.81640625 5.95703125,5.54296875 7.3125,5.54296875 C8.6640625,5.54296875 9.42578125,4.859375 9.42578125,3.859375 C9.42578125,2.953125 8.85546875,2.5390625 7.9921875,2.34765625 L7.1640625,2.1640625 C6.6953125,2.06640625 6.43359375,1.86328125 6.43359375,1.546875 C6.43359375,1.1484375 6.78125,0.85546875 7.36328125,0.85546875 C7.9296875,0.85546875 8.27734375,1.1484375 8.34375,1.51953125 L9.34375,1.51953125 C9.29296875,0.6953125 8.58984375,0 7.37109375,0 C6.1953125,0 5.37890625,0.63671875 5.37890625,1.625 C5.37890625,2.44921875 5.90234375,2.91796875 6.73046875,3.10546875 L7.5546875,3.29296875 C8.109375,3.41796875 8.375,3.6015625 8.375,3.96484375 C8.375,4.38671875 8.02734375,4.6796875 7.37109375,4.6796875 C6.7421875,4.6796875 6.34375,4.375 6.2734375,3.97265625 L5.25390625,3.97265625 Z"
  //         id="Path"
  //       ></path>
  //     </g>
  //   </g>
  // </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 512 512"
    {...props}
  >
    <path d="M45.005 95.755v320.49h421.99V95.755zm408.99 307.49H58.005v-294.49h395.99z" />
    <path d="M358.547 140.44h63.708v13h-63.708zM89.629 359.056h77.19v13h-77.19zm0-24.508h77.19v13h-77.19zm211.275-160.139-9.335-9.047a49.53 49.53 0 0 1-71.138 0l-9.335 9.047a62.53 62.53 0 0 0 89.808 0" />
    <path d="M110.9 275.74a203.78 203.78 0 0 0 290.201 0 8.206 8.206 0 0 0-.112-11.626q-.012-.015-.026-.028v-.001l-82.175-79.632a8.26 8.26 0 0 0-11.494.075 73.15 73.15 0 0 1-102.586.001 8.26 8.26 0 0 0-11.496-.076l-82.174 79.631h-.001l-.026.029a8.206 8.206 0 0 0-.111 11.627m88.077-78.772a86.25 86.25 0 0 0 114.046 0l44.53 43.152c-26.82 22.854-57.833 36.242-90.09 38.82l1.035 12.96c35.394-2.83 69.3-17.566 98.425-42.699l21.481 20.818a190.79 190.79 0 0 1-264.809 0l36.05-34.935c16.516 15.318 36.146 24.728 62.745 30.164l2.603-12.737c-24.174-4.94-41.305-12.999-56.002-26.484zm-78.894 76.453-.002.003z" />
  </svg>
);

export const ToolWindowLevel = (props: IconProps) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g strokeWidth="0" />
    <g
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 3v14m7-10v14m7-7v7m0-11V3"
      stroke="currentColor"
    />
    <path
      d="M7 19a2 2 0 1 1-2-2 2 2 0 0 1 2 2m5-16a2 2 0 1 0 2 2 2 2 0 0 0-2-2m7 7a2 2 0 1 0 2 2 2 2 0 0 0-2-2"
      stroke="#db5860"
    />
  </svg>
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  //   {...props}
  // >
  //   <g
  //     id="tool-window-level"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     ></rect>
  //     <circle
  //       id="Oval-2"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //       cx="14"
  //       cy="14"
  //       r="10"
  //     ></circle>
  //     <path
  //       d="M21.4837076,7.36702528 C23.0493155,9.13213184 24,11.4550438 24,14 C24,19.5228475 19.5228475,24 14,24 C11.4550438,24 9.13213184,23.0493155 7.36702528,21.4837076 Z"
  //       id="Combined-Shape"
  //       fill="currentColor"
  //     ></path>
  //   </g>
  // </svg>
);

export const ToolWindowRegion = (props: IconProps) => (
  // <svg
  //   width="28px"
  //   height="28px"
  //   viewBox="0 0 28 28"
  //   version="1.1"
  //   xmlns="http://www.w3.org/2000/svg"
  // >
  //   <g
  //     id="tool-window-region"
  //     stroke="none"
  //     strokeWidth="1"
  //     fill="none"
  //     fillRule="evenodd"
  //   >
  //     <rect
  //       id="Rectangle"
  //       x="0"
  //       y="0"
  //       width="28"
  //       height="28"
  //     ></rect>
  //     <path
  //       d="M10.3460449,22 L4,22 C3.44771525,22 3,21.5522847 3,21 L3,4 C3,3.44771525 3.44771525,3 4,3 L21,3 C21.5522847,3 22,3.44771525 22,4 L22,11.3197021"
  //       id="Path"
  //       stroke="currentColor"
  //       strokeWidth="1.5"
  //       strokeLinecap="round"
  //       strokeLinejoin="round"
  //     ></path>
  //     <g
  //       id="Group"
  //       transform="translate(14, 15)"
  //       fill="currentColor"
  //     >
  //       <path
  //         d="M5.5,-0.75 C8.95177969,-0.75 11.75,2.04822031 11.75,5.5 C11.75,8.95177969 8.95177969,11.75 5.5,11.75 C2.04822031,11.75 -0.75,8.95177969 -0.75,5.5 C-0.75,2.04822031 2.04822031,-0.75 5.5,-0.75 Z M5.5,0.75 C2.87664744,0.75 0.75,2.87664744 0.75,5.5 C0.75,8.12335256 2.87664744,10.25 5.5,10.25 C8.12335256,10.25 10.25,8.12335256 10.25,5.5 C10.25,2.87664744 8.12335256,0.75 5.5,0.75 Z"
  //         id="Oval"
  //         fillRule="nonzero"
  //       ></path>
  //       <path
  //         d="M9.61552427,1.85128344 C10.4769151,2.82216322 11,4.09999509 11,5.5 C11,8.53756612 8.53756612,11 5.5,11 C4.09999509,11 2.82216322,10.4769151 1.85128344,9.61552427 Z"
  //         id="Combined-Shape"
  //       ></path>
  //     </g>
  //   </g>
  // </svg>
  <svg
    clipRule="evenodd"
    fillRule="evenodd"
    height="25"
    viewBox="0 0 512 512"
    width="25"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21 68h378c7 0 13 6 13 13v155h-17V108H26v230h254v17H8V81c0-7 6-13 13-13m379 214c39 0 71 32 71 71s-32 71-71 71h-1V282zM63 158h215v23H63zm0 106h215v23H63zm0-53h215v23H63zm337 42c55 0 100 45 100 100s-45 100-100 100-100-45-100-100 45-100 100-100m0 18c45 0 82 37 82 83s-37 83-82 83-82-37-82-83 37-83 82-83"
      fill="currentColor"
    />
  </svg>
);

export const ToolZoom = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-zoom"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <ellipse
        id="Oval-1"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        cx="11.5581395"
        cy="12.0909091"
        rx="7.81395349"
        ry="7.63636364"
      ></ellipse>
      <line
        x1="17.4186047"
        y1="17.8181818"
        x2="23.2790698"
        y2="23.5454545"
        id="Line"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
    </g>
  </svg>
);

export const ToolBrush = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-seg-brush"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <path
        d="M3.24640621,21.8286833 C3.09173375,21.7551472 2.99513748,21.5971513 3.00018895,21.4259625 C3.00524042,21.2547737 3.11098486,21.1027485 3.26972426,21.0384606 C5.3260304,20.2059201 4.66362518,17.8620247 5.27421252,16.6088957 C6.02197747,15.1026514 7.84114758,14.4766383 9.35746132,15.2037675 C13.9485253,17.4422999 8.48346644,24.3211232 3.24640621,21.8286833 Z"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M21.5968442,2.302022 C21.1256527,1.8826075 20.4094461,1.90228142 19.9619901,2.34693083 L9.69255027,12.5887345 C11.0536437,13.0051578 12.1843437,13.9616637 12.8206229,15.2349008 L21.7410706,3.93687606 C22.1347378,3.44008272 22.0714081,2.72222021 21.5968442,2.302022 Z"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </g>
  </svg>
);

export const ToolEraser = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-seg-eraser"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <path
        d="M8.47826087,18.0030772 C7.48731947,17.9495317 6.54439458,17.5591084 5.80565217,16.8964685 L4.1066087,15.1958598 C3.49763625,14.5834856 3.49763625,13.5942339 4.1066087,12.9818598 L13.6317391,3.45672934 C14.2441133,2.84775689 15.233365,2.84775689 15.8457391,3.45672934 L19.8926087,7.5035989 C20.5015811,8.11597307 20.5015811,9.10522473 19.8926087,9.7175989 L12.7153043,16.8949033 C11.9769855,17.5579476 11.0343414,17.9489213 10.0434783,18.0030772 L8.47826087,18.0030772 Z"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <line
        x1="10.0434783"
        y1="7.04499021"
        x2="16.3043478"
        y2="13.3058598"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
      <line
        x1="3"
        y1="20.5667293"
        x2="21"
        y2="20.5667293"
        id="Path"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></line>
    </g>
  </svg>
);

export const ToolThreshold = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-seg-threshold"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <g
        id="Group"
        transform="translate(2.4184, 14.3673)"
        stroke="currentColor"
        strokeWidth="1.5"
      >
        <line
          x1="16.5816327"
          y1="2.13265306"
          x2="19.0816327"
          y2="2.13265306"
          id="Line-2"
          strokeLinecap="round"
        ></line>
        <line
          x1="0.0816326531"
          y1="2.13265306"
          x2="12.0816327"
          y2="2.13265306"
          id="Line-2"
          strokeLinecap="round"
        ></line>
        <circle
          id="Oval"
          cx="14.2244898"
          cy="2.09183673"
          r="2.09183673"
        ></circle>
      </g>
      <g
        id="Group"
        transform="translate(11.7092, 7.4592) scale(-1, 1) translate(-11.7092, -7.4592)translate(1.9184, 5.3673)"
        stroke="currentColor"
        strokeWidth="1.5"
      >
        <line
          x1="16"
          y1="2.13265306"
          x2="19.0816327"
          y2="2.13265306"
          id="Line-2"
          strokeLinecap="round"
        ></line>
        <line
          x1="0.0816326531"
          y1="2.13265306"
          x2="11"
          y2="2.13265306"
          id="Line-2"
          strokeLinecap="round"
        ></line>
        <circle
          id="Oval"
          cx="13.2244898"
          cy="2.09183673"
          r="2.09183673"
        ></circle>
      </g>
    </g>
  </svg>
);

export const ToolShape = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 28 28"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="tool-seg-shape"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <rect
        id="Rectangle"
        x="0"
        y="0"
        width="28"
        height="28"
      ></rect>
      <circle
        id="Oval"
        stroke="currentColor"
        strokeWidth="1.5"
        cx="16"
        cy="15"
        r="6"
      ></circle>
      <rect
        id="Rectangle"
        stroke="currentColor"
        strokeWidth="1.5"
        x="3"
        y="3"
        width="13"
        height="13"
        rx="2"
      ></rect>
    </g>
  </svg>
);

export const ToolLabelmapAssist = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M15.896 11.3736L17.2416 8.6832L21.55 7.07903C21.9997 6.89305 22.3572 6.53602 22.5437 6.08648C22.7302 5.63693 22.7305 5.13171 22.5445 4.68195C22.3586 4.23219 22.0015 3.87473 21.552 3.6882C21.1025 3.50168 20.5972 3.50138 20.1475 3.68737L7.61663 9.14153L5.0573 7.8582C4.99771 7.82826 4.93231 7.81168 4.86566 7.80962C4.799 7.80756 4.7327 7.82007 4.67138 7.84628L2.27797 8.87295C2.20912 8.90242 2.14854 8.94832 2.10153 9.00662C2.05452 9.06493 2.02251 9.13386 2.00831 9.2074C1.99411 9.28093 1.99815 9.35683 2.02007 9.42844C2.04199 9.50006 2.08112 9.56521 2.13405 9.6182L5.56697 13.0511C5.63034 13.1145 5.71093 13.158 5.79875 13.1761C5.88657 13.1942 5.97777 13.1861 6.06105 13.1529L12.6583 10.5165"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0279 5.48134L10.0971 3.03476C9.98496 2.98841 9.85903 2.98841 9.74691 3.03476L7.557 3.94318C7.47321 3.97785 7.4016 4.03659 7.35121 4.11198C7.30082 4.18736 7.27393 4.276 7.27393 4.36668C7.27393 4.45735 7.30082 4.54599 7.35121 4.62137C7.4016 4.69676 7.47321 4.7555 7.557 4.79018L12.7123 6.92326"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.0447 16.2917C18.0447 16.0585 17.9116 15.9187 17.6456 15.872C17.0203 15.7721 16.5315 15.6789 16.1789 15.5923C15.8264 15.4991 15.567 15.3658 15.4007 15.1927C15.2277 15.0195 15.1047 14.7664 15.0315 14.4334C14.9517 14.0937 14.8752 13.6241 14.802 13.0246C14.7821 12.9047 14.7355 12.8082 14.6624 12.7349C14.5825 12.6616 14.4894 12.625 14.383 12.625C14.2766 12.625 14.1835 12.6616 14.1036 12.7349C14.0238 12.8015 13.9739 12.8914 13.954 13.0047C13.8742 13.6174 13.7943 14.0903 13.7145 14.4234C13.628 14.7564 13.4983 15.0062 13.3254 15.1727C13.1458 15.3392 12.8831 15.4691 12.5372 15.5623C12.1847 15.6489 11.6991 15.7522 11.0805 15.872C10.9674 15.892 10.8776 15.942 10.8111 16.0219C10.7446 16.1018 10.7113 16.1918 10.7113 16.2917C10.7113 16.3982 10.7479 16.4915 10.8211 16.5714C10.8876 16.6447 10.9774 16.6913 11.0905 16.7113C11.6958 16.7979 12.1747 16.8811 12.5272 16.9611C12.8731 17.0343 13.1358 17.1575 13.3154 17.3307C13.495 17.4972 13.628 17.7537 13.7145 18.1C13.7943 18.453 13.8742 18.9426 13.954 19.5687C13.9739 19.6819 14.0238 19.7752 14.1036 19.8484C14.1768 19.9217 14.2699 19.9583 14.383 19.9583C14.4894 19.9583 14.5825 19.9184 14.6624 19.8384C14.7355 19.7652 14.7821 19.6719 14.802 19.5587C14.8752 18.9592 14.9517 18.493 15.0315 18.16C15.1047 17.8269 15.2277 17.5772 15.4007 17.4106C15.5736 17.2441 15.8397 17.1176 16.1989 17.031C16.5514 16.9377 17.0469 16.8312 17.6855 16.7113C17.7919 16.6913 17.8784 16.6413 17.9449 16.5614C18.0114 16.4815 18.0447 16.3916 18.0447 16.2917Z"
      fill="currentColor"
    />
    <path
      d="M12.5447 20.4167C12.5447 20.271 12.4615 20.1835 12.2952 20.1544C11.9045 20.092 11.5989 20.0337 11.3786 19.9796C11.1582 19.9213 10.9961 19.838 10.8922 19.7298C10.7841 19.6216 10.7072 19.4634 10.6615 19.2552C10.6116 19.0429 10.5638 18.7494 10.518 18.3748C10.5056 18.2998 10.4765 18.2395 10.4307 18.1937C10.3808 18.1479 10.3226 18.125 10.2561 18.125C10.1896 18.125 10.1314 18.1479 10.0815 18.1937C10.0316 18.2353 10.0005 18.2915 9.98799 18.3623C9.9381 18.7453 9.88822 19.0408 9.83833 19.249C9.78428 19.4571 9.70322 19.6132 9.59513 19.7173C9.48289 19.8214 9.31868 19.9026 9.1025 19.9608C8.88217 20.0149 8.57869 20.0795 8.19207 20.1544C8.1214 20.1669 8.06528 20.1981 8.0237 20.2481C7.98213 20.298 7.96134 20.3542 7.96134 20.4167C7.96134 20.4833 7.98421 20.5416 8.02994 20.5915C8.07151 20.6373 8.12763 20.6664 8.19831 20.6789C8.57661 20.733 8.87593 20.7851 9.09627 20.835C9.31244 20.8808 9.47665 20.9578 9.5889 21.0661C9.70114 21.1701 9.78428 21.3304 9.83833 21.5469C9.88822 21.7675 9.9381 22.0735 9.98799 22.4648C10.0005 22.5356 10.0316 22.5939 10.0815 22.6396C10.1273 22.6854 10.1855 22.7083 10.2561 22.7083C10.3226 22.7083 10.3808 22.6834 10.4307 22.6334C10.4765 22.5876 10.5056 22.5293 10.518 22.4586C10.5638 22.0839 10.6116 21.7925 10.6615 21.5844C10.7072 21.3762 10.7841 21.2201 10.8922 21.116C11.0003 21.012 11.1666 20.9329 11.391 20.8787C11.6114 20.8205 11.9211 20.7539 12.3202 20.6789C12.3867 20.6664 12.4407 20.6352 12.4823 20.5853C12.5239 20.5353 12.5447 20.4791 12.5447 20.4167Z"
      fill="currentColor"
    />
  </svg>
);
export const ToolSegmentAnything = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M12.5566 8.9332C12.5566 8.76203 12.459 8.65932 12.2636 8.62508C11.8045 8.55172 11.4455 8.48325 11.1867 8.41967C10.9278 8.3512 10.7373 8.25339 10.6152 8.12623C10.4882 7.99907 10.3979 7.81322 10.3441 7.56868C10.2855 7.31925 10.2294 6.97446 10.1756 6.53429C10.161 6.44626 10.1268 6.37534 10.0731 6.32154C10.0145 6.26774 9.94609 6.24084 9.86795 6.24084C9.7898 6.24084 9.72142 6.26774 9.66282 6.32154C9.60421 6.37045 9.56758 6.43647 9.55292 6.51962C9.49431 6.96957 9.4357 7.31681 9.3771 7.56135C9.3136 7.80588 9.21836 7.98929 9.09138 8.11156C8.95951 8.23382 8.76658 8.32919 8.51261 8.39766C8.25375 8.46124 7.89722 8.53705 7.44299 8.62508C7.35996 8.63976 7.29403 8.67644 7.24519 8.73513C7.19635 8.79381 7.17193 8.85984 7.17193 8.9332C7.17193 9.01145 7.19879 9.07992 7.25251 9.13861C7.30136 9.19241 7.36729 9.22665 7.45032 9.24132C7.89477 9.3049 8.24643 9.36603 8.50528 9.42472C8.75926 9.47852 8.95218 9.569 9.08405 9.69616C9.21592 9.81843 9.3136 10.0067 9.3771 10.261C9.4357 10.5202 9.49431 10.8797 9.55292 11.3394C9.56758 11.4226 9.60421 11.4911 9.66282 11.5449C9.71654 11.5987 9.78492 11.6256 9.86795 11.6256C9.94609 11.6256 10.0145 11.5962 10.0731 11.5375C10.1268 11.4837 10.161 11.4153 10.1756 11.3321C10.2294 10.8919 10.2855 10.5496 10.3441 10.3051C10.3979 10.0605 10.4882 9.87712 10.6152 9.75485C10.7422 9.63258 10.9376 9.53965 11.2013 9.47607C11.4602 9.4076 11.824 9.32935 12.2929 9.24132C12.371 9.22665 12.4345 9.18997 12.4834 9.13128C12.5322 9.07259 12.5566 9.00656 12.5566 8.9332Z"
      fill="currentColor"
    />
    <path
      d="M17.9415 13.8691C17.9415 13.6123 17.7949 13.4583 17.5019 13.4069C16.8132 13.2969 16.2748 13.1942 15.8865 13.0988C15.4982 12.9961 15.2125 12.8494 15.0293 12.6586C14.8388 12.4679 14.7033 12.1891 14.6227 11.8223C14.5348 11.4482 14.4506 10.931 14.37 10.2707C14.348 10.1387 14.2967 10.0323 14.2161 9.95161C14.1282 9.87092 14.0256 9.83057 13.9084 9.83057C13.7912 9.83057 13.6886 9.87092 13.6007 9.95161C13.5128 10.025 13.4579 10.124 13.4359 10.2487C13.348 10.9236 13.2601 11.4445 13.1722 11.8113C13.0769 12.1781 12.9341 12.4532 12.7436 12.6366C12.5458 12.82 12.2564 12.9631 11.8754 13.0658C11.4871 13.1612 10.9523 13.2749 10.271 13.4069C10.1465 13.4289 10.0476 13.484 9.97429 13.572C9.90103 13.66 9.8644 13.7591 9.8644 13.8691C9.8644 13.9865 9.90469 14.0892 9.98528 14.1772C10.0585 14.2579 10.1574 14.3093 10.282 14.3313C10.9487 14.4266 11.4761 14.5183 11.8644 14.6064C12.2454 14.6871 12.5348 14.8228 12.7326 15.0135C12.9304 15.1969 13.0769 15.4794 13.1722 15.8609C13.2601 16.2497 13.348 16.7889 13.4359 17.4785C13.4579 17.6032 13.5128 17.7059 13.6007 17.7866C13.6813 17.8673 13.7839 17.9076 13.9084 17.9076C14.0256 17.9076 14.1282 17.8636 14.2161 17.7756C14.2967 17.6949 14.348 17.5922 14.37 17.4675C14.4506 16.8072 14.5348 16.2937 14.6227 15.9269C14.7033 15.5601 14.8388 15.285 15.0293 15.1016C15.2198 14.9182 15.5129 14.7788 15.9085 14.6834C16.2967 14.5807 16.8425 14.4633 17.5459 14.3313C17.6631 14.3093 17.7583 14.2542 17.8316 14.1662C17.9048 14.0782 17.9415 13.9791 17.9415 13.8691Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.3823 17.7373C19.0569 16.1757 20.044 14.1881 20.3223 12.1916C20.656 9.79757 20.2606 7.22773 18.7177 5.57321C17.0356 3.76929 14.2662 3.24208 11.6462 3.60868C9.83542 3.86207 8.02625 4.68764 6.52164 6.09072C4.92546 7.57918 3.9538 9.4548 3.62536 11.3563C3.21073 13.7569 3.82082 16.1818 5.47407 17.9547C7.20202 19.8077 9.72139 20.5742 12.2577 20.2193C14.0685 19.9659 15.8777 19.1403 17.3823 17.7373ZM21.8079 12.3987C21.4817 14.7386 20.3299 17.0396 18.4053 18.8343C16.6759 20.447 14.5823 21.4086 12.4656 21.7048C9.50415 22.1192 6.47736 21.23 4.37704 18.9777C2.36838 16.8236 1.66208 13.91 2.14725 11.101C2.5317 8.87524 3.66405 6.70447 5.49864 4.99369C7.22808 3.38096 9.32167 2.41934 11.4383 2.12316C14.3161 1.72048 17.6687 2.24881 19.8148 4.55022C21.7914 6.66994 22.1731 9.77848 21.8079 12.3987Z"
      fill="currentColor"
    />
  </svg>
);
export const ToolPETSegment = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M20.7108 20.7795C20.2638 20.7795 19.9924 20.4921 19.9924 20.0132V14.6703H18.4545C18.098 14.6703 17.8372 14.4148 17.8372 14.0689C17.8372 13.7177 18.098 13.4623 18.4545 13.4623H22.9724C23.3343 13.4623 23.5897 13.7124 23.5897 14.0689C23.5897 14.4202 23.3343 14.6703 22.9724 14.6703H21.4292V20.0132C21.4292 20.4868 21.1525 20.7795 20.7108 20.7795Z"
      fill="currentColor"
    />
    <path
      d="M12.8614 20.7795C12.4091 20.7795 12.1483 20.4921 12.1483 20.0025V14.5106C12.1483 13.755 12.4357 13.4623 13.186 13.4623H15.0219C16.5332 13.4623 17.507 14.4095 17.507 15.8464C17.507 17.347 16.5226 18.2357 14.9634 18.2357H13.5851V20.0025C13.5851 20.4921 13.319 20.7795 12.8614 20.7795ZM13.5851 17.1182H14.5057C15.6232 17.1182 16.0755 16.7936 16.0755 15.8676C16.0755 15.0694 15.6285 14.6117 14.841 14.6117H13.5851V17.1182Z"
      fill="currentColor"
    />
    <path
      d="M16.2855 10.7063C16.5677 8.68223 16.254 6.39013 14.8334 4.86666C13.2881 3.20953 10.8171 2.78346 8.59798 3.09398C7.01269 3.31581 5.43737 4.03721 4.13198 5.25454C2.74718 6.54592 1.89791 8.17926 1.61016 9.84527C1.24697 11.9481 1.77832 14.1031 3.25643 15.6882C4.80168 17.3453 7.04033 18.0136 9.25943 17.7031"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
export const ToolInterpolation = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M4 12.5H20"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8 2.5H16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8 21.5H16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M10 7.5H14"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M10 16.5H14"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
export const ToolBidirectionalSegment = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M6.1853 15.6532L18.4009 8.77848"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8.76544 7.91235L13.832 16.5978"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M4.14157 17.3088C2.76981 15.2751 2.67514 12.6925 3.6387 10.2811C4.4021 8.37067 5.82976 6.56762 7.81284 5.23002C9.6822 3.96912 12.3566 4.73828 14.311 4.67465C17.0466 4.58559 19.2925 3.97045 20.7266 6.09655C22.045 8.05118 20.748 11.3759 19.9013 13.7053C19.1692 15.7197 18.7965 17.0264 16.7161 18.4296C14.8467 19.6905 12.7787 20.3389 10.8244 20.4025C8.0887 20.4916 5.57565 19.4349 4.14157 17.3088Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
export const ToolExpand = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M19.9346 11.1104C19.7061 11.1104 19.5156 11.0342 19.3633 10.8818C19.2109 10.7236 19.1348 10.5273 19.1348 10.293V9.55469L19.3193 6.4873L16.999 8.92188L14.3008 11.6465C14.1543 11.7988 13.9668 11.875 13.7383 11.875C13.4922 11.875 13.2842 11.8018 13.1143 11.6553C12.9502 11.5029 12.8682 11.3037 12.8682 11.0576C12.8682 10.9404 12.8887 10.8291 12.9297 10.7236C12.9707 10.6182 13.0322 10.5273 13.1143 10.4512L15.8213 7.74414L18.2646 5.43262L15.1885 5.6084H14.4502C14.2158 5.6084 14.0195 5.53516 13.8613 5.38867C13.7031 5.23633 13.624 5.04297 13.624 4.80859C13.624 4.57422 13.7031 4.38086 13.8613 4.22852C14.0195 4.07617 14.2158 4 14.4502 4H19.3281C19.7793 4 20.1279 4.12598 20.374 4.37793C20.626 4.62402 20.752 4.96973 20.752 5.41504V10.293C20.752 10.5215 20.6729 10.7148 20.5146 10.873C20.3623 11.0312 20.1689 11.1104 19.9346 11.1104ZM10.293 20.7695H5.41504C4.96973 20.7695 4.62109 20.6436 4.36914 20.3916C4.12305 20.1455 4 19.7998 4 19.3545V14.4766C4 14.248 4.07617 14.0547 4.22852 13.8965C4.38086 13.7383 4.57422 13.6592 4.80859 13.6592C5.04297 13.6592 5.2334 13.7383 5.37988 13.8965C5.53223 14.0488 5.6084 14.2422 5.6084 14.4766V15.2148L5.43262 18.2822L7.74414 15.8477L10.4512 13.123C10.5977 12.9707 10.7822 12.8945 11.0049 12.8945C11.2568 12.8945 11.4648 12.9707 11.6289 13.123C11.793 13.2695 11.875 13.4658 11.875 13.7119C11.875 13.8291 11.8545 13.9404 11.8135 14.0459C11.7725 14.1514 11.7139 14.2422 11.6377 14.3184L8.92188 17.0254L6.4873 19.3369L9.56348 19.1611H10.293C10.5273 19.1611 10.7236 19.2344 10.8818 19.3809C11.04 19.5332 11.1191 19.7266 11.1191 19.9609C11.1191 20.1953 11.04 20.3887 10.8818 20.541C10.7295 20.6934 10.5332 20.7695 10.293 20.7695Z"
      fill="currentColor"
    />
  </svg>
);
export const ToolContract = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M13.1162 5.08203C13.1162 4.84766 13.1924 4.65137 13.3447 4.49316C13.4971 4.33496 13.6904 4.25586 13.9248 4.25586C14.1592 4.25586 14.3496 4.33496 14.4961 4.49316C14.6484 4.65137 14.7246 4.84766 14.7246 5.08203V5.82031L14.5488 8.8877L16.8604 6.45312L19.5674 3.74609C19.6494 3.66406 19.7402 3.60254 19.8398 3.56152C19.9453 3.52051 20.0566 3.5 20.1738 3.5C20.4199 3.5 20.6191 3.58203 20.7715 3.74609C20.9238 3.91016 21 4.11816 21 4.37012C21 4.59277 20.9209 4.78027 20.7627 4.93262L18.0381 7.63086L15.6035 9.95117L18.6709 9.7666H19.4092C19.6436 9.7666 19.8369 9.83984 19.9893 9.98633C20.1475 10.1387 20.2266 10.332 20.2266 10.5664C20.2266 10.8008 20.1475 10.9941 19.9893 11.1465C19.8311 11.2988 19.6377 11.375 19.4092 11.375H14.54C14.0889 11.375 13.7373 11.252 13.4854 11.0059C13.2393 10.7598 13.1162 10.4111 13.1162 9.95996V5.08203ZM4.19531 13.5107C4.19531 13.2764 4.27441 13.083 4.43262 12.9307C4.58496 12.7783 4.77832 12.7021 5.0127 12.7021H9.97852C10.4297 12.7021 10.7783 12.8252 11.0244 13.0713C11.2705 13.3174 11.3936 13.666 11.3936 14.1172V19.0918C11.3936 19.3262 11.3174 19.5225 11.165 19.6807C11.0186 19.8389 10.8252 19.918 10.585 19.918C10.3506 19.918 10.1602 19.8389 10.0137 19.6807C9.86719 19.5225 9.79395 19.3262 9.79395 19.0918V18.2568L9.96973 15.1807L7.6582 17.624L4.88965 20.3926C4.80762 20.4688 4.7168 20.5273 4.61719 20.5684C4.51172 20.6094 4.40039 20.6299 4.2832 20.6299C4.03711 20.6299 3.83789 20.5479 3.68555 20.3838C3.5332 20.2197 3.45703 20.0146 3.45703 19.7686C3.45703 19.54 3.53613 19.3525 3.69434 19.2061L6.47168 16.4463L8.90625 14.126L5.84766 14.3105H5.0127C4.77832 14.3105 4.58496 14.2344 4.43262 14.082C4.27441 13.9297 4.19531 13.7393 4.19531 13.5107Z"
      fill="currentColor"
    />
  </svg>
);
export const ToolSculptor = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M16.5 1.5C19.2614 1.5 21.5 3.73858 21.5 6.5C21.5 8.59844 20.2065 10.3931 18.374 11.1348C18.4555 11.5776 18.5 12.0336 18.5 12.5C18.5 16.6421 15.1421 20 11 20C10.6311 20 10.4428 19.5684 10.6035 19.2363C10.8575 18.7113 11 18.1224 11 17.5C11 15.2909 9.20914 13.5 7 13.5C6.07751 13.5 5.22759 13.8124 4.55078 14.3369C4.24235 14.5757 3.75506 14.4797 3.67188 14.0986C3.55945 13.5836 3.5 13.0488 3.5 12.5C3.5 8.35786 6.85786 5 11 5C11.2421 5 11.4815 5.01272 11.7178 5.03516C12.3439 2.98844 14.2482 1.5 16.5 1.5ZM16.4707 3.53125C16.1133 3.53125 15.8906 3.7832 15.8906 4.14648V6.07422H14.0684C13.7109 6.07422 13.4648 6.29688 13.4648 6.64844C13.4648 7 13.7109 7.2168 14.0684 7.2168H15.8906V9.13867C15.8906 9.50195 16.1133 9.75391 16.4707 9.75391C16.8223 9.75391 17.0449 9.50195 17.0449 9.13867V7.2168H18.8613C19.2188 7.2168 19.4707 7 19.4707 6.64844C19.4707 6.29688 19.2188 6.07422 18.8613 6.07422H17.0449V4.14648C17.0449 3.7832 16.8223 3.53125 16.4707 3.53125Z"
      fill="currentColor"
    />
    <path
      d="M5.69531 18.1406C5.34375 18.1406 5.08594 17.9238 5.08594 17.5664C5.08594 17.2148 5.34375 16.998 5.69531 16.998H8.50195C8.85352 16.998 9.11719 17.2148 9.11719 17.5664C9.11719 17.9238 8.85352 18.1406 8.50195 18.1406H5.69531Z"
      fill="currentColor"
    />
    <circle
      cx="7"
      cy="17.5"
      r="4.5"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);
export const ToolLabelmapEditWithContour = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M10.3945 12.6113C10.043 12.6113 9.78516 12.3945 9.78516 12.0371C9.78516 11.6855 10.043 11.4688 10.3945 11.4688H13.2012C13.5527 11.4688 13.8164 11.6855 13.8164 12.0371C13.8164 12.3945 13.5527 12.6113 13.2012 12.6113H10.3945Z"
      fill="currentColor"
    />
    <path
      opacity="0.5"
      d="M18.312 6.84473C21.8473 8.88583 22.9225 13.6424 20.7134 17.4687C18.5042 21.2951 13.8473 22.7422 10.312 20.7011C9.51661 20.2419 8.84737 19.6439 8.31042 18.9512C11.3012 19.3598 14.4827 17.8251 16.1946 14.8598C17.9067 11.8945 17.6457 8.3712 15.7963 5.98538C16.6645 6.10409 17.5167 6.38556 18.312 6.84473Z"
      fill="currentColor"
    />
    <circle
      cx="13.7852"
      cy="13.4688"
      r="8"
      stroke="currentColor"
    />
    <path
      d="M4.50586 8.22266C4.14844 8.22266 3.92578 7.9707 3.92578 7.60742V5.68555H2.10352C1.74609 5.68555 1.5 5.46875 1.5 5.11719C1.5 4.76562 1.74609 4.54297 2.10352 4.54297H3.92578V2.61523C3.92578 2.25195 4.14844 2 4.50586 2C4.85742 2 5.08008 2.25195 5.08008 2.61523V4.54297H6.89648C7.25391 4.54297 7.50586 4.76562 7.50586 5.11719C7.50586 5.46875 7.25391 5.68555 6.89648 5.68555H5.08008V7.60742C5.08008 7.9707 4.85742 8.22266 4.50586 8.22266Z"
      fill="currentColor"
    />
  </svg>
);
export const ToolSegmentLabel = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M2.6636 14.3578C2.58841 14.4105 2.53094 14.4847 2.49878 14.5707C2.46661 14.6567 2.46127 14.7504 2.48345 14.8395C2.50564 14.9286 2.5543 15.0088 2.62302 15.0697C2.69175 15.1305 2.77731 15.1691 2.86842 15.1804L7.42867 16.5722L8.82125 21.1316C8.83209 21.2229 8.87047 21.3088 8.93131 21.3779C8.99214 21.4469 9.07254 21.4958 9.16181 21.518C9.25109 21.5402 9.34502 21.5348 9.43111 21.5023C9.5172 21.4699 9.59139 21.412 9.6438 21.3364L20.4127 10.5683C20.7607 10.1801 20.9661 9.68484 20.9951 9.16423L21 3.82256C21 3.6044 20.9133 3.39518 20.7591 3.24092C20.6048 3.08666 20.3956 3 20.1774 3H14.8382C14.3176 3.02823 13.8223 3.2334 13.4341 3.58155L2.6636 14.3578Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.8882 8.75787C15.9796 8.75787 15.2431 8.02133 15.2431 7.11276C15.2431 6.20419 15.9796 5.46765 16.8882 5.46765C17.7968 5.46765 18.5333 6.20419 18.5333 7.11276C18.5333 8.02133 17.7968 8.75787 16.8882 8.75787Z"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
